function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st3{font-family:'Graphik';font-size:10px;fill: 'black';}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "OR03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "9.8,163.1 9.8,159.7 12.8,158 15.7,159.7 15.7,163.1 12.8,164.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M12.8,158.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L12.8,158.5 M12.8,157.4l-3.4,2v4l3.4,2l3.4-2v-4L12.8,157.4 L12.8,157.4z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "OR04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "16.9,163.1 16.9,159.7 19.9,158 22.8,159.7 22.8,163.1 19.9,164.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M19.9,158.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L19.9,158.5 M19.9,157.4l-3.4,2v4l3.4,2l3.4-2v-4L19.9,157.4 L19.9,157.4z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "OR05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "24,163.1 24,159.7 26.9,158 29.9,159.7 29.9,163.1 26.9,164.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M26.9,158.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L26.9,158.5 M26.9,157.4l-3.4,2v4l3.4,2l3.4-2v-4L26.9,157.4 L26.9,157.4z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "OR01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "13.4,156.9 13.4,153.5 16.3,151.8 19.2,153.5 19.2,156.9 16.3,158.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M16.3,152.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L16.3,152.4 M16.3,151.2l-3.4,2v4l3.4,2l3.4-2v-4L16.3,151.2 L16.3,151.2z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "OR02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "20.5,156.9 20.5,153.5 23.4,151.8 26.3,153.5 26.3,156.9 23.4,158.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M23.4,152.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L23.4,152.4 M23.4,151.2l-3.4,2v4l3.4,2l3.4-2v-4L23.4,151.2 L23.4,151.2z"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "ID02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "42,157.8 42,154.4 44.9,152.7 47.8,154.4 47.8,157.8 44.9,159.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M44.9,153.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L44.9,153.3 M44.9,152.1l-3.4,2v4l3.4,2l3.4-2v-4L44.9,152.1 L44.9,152.1z"
}));

var _ref9 = /*#__PURE__*/React.createElement("g", {
  id: "ID01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "38.4,151.7 38.4,148.3 41.4,146.6 44.3,148.3 44.3,151.7 41.4,153.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M41.4,147.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L41.4,147.2 M41.4,146l-3.4,2v4l3.4,2l3.4-2v-4L41.4,146 L41.4,146z"
}));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  id: "WA01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "7.2,123.3 7.2,119.9 10.1,118.2 13.1,119.9 13.1,123.3 10.1,125  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M10.1,118.8l2.4,1.4v2.8l-2.4,1.4L7.7,123v-2.8L10.1,118.8 M10.1,117.7l-3.4,2v4l3.4,2l3.4-2v-4L10.1,117.7 L10.1,117.7z"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  id: "WA02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "21.5,123.3 21.5,119.9 24.4,118.2 27.3,119.9 27.3,123.3 24.4,125  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M24.4,118.8l2.4,1.4v2.8l-2.4,1.4L22,123v-2.8L24.4,118.8 M24.4,117.7l-3.4,2v4l3.4,2l3.4-2v-4L24.4,117.7 L24.4,117.7z"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "WA03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "28.6,123.3 28.6,119.9 31.6,118.2 34.5,119.9 34.5,123.3 31.6,125  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M31.6,118.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L31.6,118.8 M31.6,117.7l-3.4,2v4l3.4,2l3.4-2v-4L31.6,117.7 L31.6,117.7z"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  id: "WA04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "10.8,129.5 10.8,126.1 13.7,124.4 16.6,126.1 16.6,129.5 13.7,131.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M13.7,125l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L13.7,125 M13.7,123.8l-3.4,2v4l3.4,2l3.4-2v-4L13.7,123.8 L13.7,123.8z"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  id: "WA08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "14.3,135.7 14.3,132.3 17.3,130.6 20.2,132.3 20.2,135.7 17.3,137.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M17.3,131.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L17.3,131.2 M17.3,130l-3.4,2v4l3.4,2l3.4-2v-4L17.3,130 L17.3,130z"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  id: "WA09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "21.5,135.7 21.5,132.3 24.4,130.6 27.3,132.3 27.3,135.7 24.4,137.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M24.4,131.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L24.4,131.2 M24.4,130l-3.4,2v4l3.4,2l3.4-2v-4L24.4,130 L24.4,130z"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  id: "WA10"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "28.6,135.7 28.6,132.3 31.5,130.6 34.5,132.3 34.5,135.7 31.5,137.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M31.5,131.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L31.5,131.2 M31.5,130l-3.4,2v4l3.4,2l3.4-2v-4L31.5,130 L31.5,130z"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  id: "WA05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "17.9,129.5 17.9,126.1 20.8,124.4 23.8,126.1 23.8,129.5 20.8,131.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M20.8,125l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L20.8,125 M20.8,123.8l-3.4,2v4l3.4,2l3.4-2v-4L20.8,123.8 L20.8,123.8z"
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  id: "WA06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "25.1,129.5 25.1,126.1 28,124.4 30.9,126.1 30.9,129.5 28,131.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M28,125l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L28,125 M28,123.8l-3.4,2v4l3.4,2l3.4-2v-4L28,123.8L28,123.8z"
}));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  id: "WA07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "32.2,129.5 32.2,126.1 35.1,124.4 38,126.1 38,129.5 35.1,131.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M35.1,125l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L35.1,125 M35.1,123.8l-3.4,2v4l3.4,2l3.4-2v-4L35.1,123.8 L35.1,123.8z"
}));

var _ref20 = /*#__PURE__*/React.createElement("g", {
  id: "CO01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "66.2,175.8 66.2,172.4 69.1,170.7 72,172.4 72,175.8 69.1,177.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M69.1,171.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L69.1,171.3 M69.1,170.2l-3.4,2v4l3.4,2l3.4-2v-4L69.1,170.2 L69.1,170.2z"
}));

var _ref21 = /*#__PURE__*/React.createElement("g", {
  id: "CO05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "69.7,182 69.7,178.6 72.7,176.9 75.6,178.6 75.6,182 72.7,183.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M72.7,177.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L72.7,177.5 M72.7,176.3l-3.4,2v4l3.4,2l3.4-2v-4L72.7,176.3 L72.7,176.3z"
}));

var _ref22 = /*#__PURE__*/React.createElement("g", {
  id: "CO06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "76.9,182 76.9,178.6 79.9,176.9 82.8,178.6 82.8,182 79.9,183.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M79.9,177.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L79.9,177.5 M79.9,176.3l-3.4,2v4l3.4,2l3.4-2v-4L79.9,176.3 L79.9,176.3z"
}));

var _ref23 = /*#__PURE__*/React.createElement("g", {
  id: "CO07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "84.1,182 84.1,178.6 87,176.9 89.9,178.6 89.9,182 87,183.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M87,177.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L87,177.5 M87,176.3l-3.4,2v4l3.4,2l3.4-2v-4L87,176.3L87,176.3z "
}));

var _ref24 = /*#__PURE__*/React.createElement("g", {
  id: "CO02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "73.3,175.8 73.3,172.4 76.3,170.7 79.2,172.4 79.2,175.8 76.3,177.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M76.3,171.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L76.3,171.3 M76.3,170.2l-3.4,2v4l3.4,2l3.4-2v-4L76.3,170.2 L76.3,170.2z"
}));

var _ref25 = /*#__PURE__*/React.createElement("g", {
  id: "CO03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "80.5,175.8 80.5,172.4 83.4,170.7 86.4,172.4 86.4,175.8 83.4,177.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M83.4,171.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L83.4,171.3 M83.4,170.2l-3.4,2v4l3.4,2l3.4-2v-4L83.4,170.2 L83.4,170.2z"
}));

var _ref26 = /*#__PURE__*/React.createElement("g", {
  id: "CO04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "87.6,175.8 87.6,172.4 90.6,170.7 93.5,172.4 93.5,175.8 90.6,177.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M90.6,171.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L90.6,171.3 M90.6,170.2l-3.4,2v4l3.4,2l3.4-2v-4L90.6,170.2 L90.6,170.2z"
}));

var _ref27 = /*#__PURE__*/React.createElement("g", {
  id: "TX21"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "87.7,262.3 87.7,258.9 90.6,257.2 93.6,258.9 93.6,262.3 90.6,264  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M90.6,257.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L90.6,257.7 M90.6,256.6l-3.4,2v4l3.4,2l3.4-2v-4L90.6,256.6 L90.6,256.6z"
}));

var _ref28 = /*#__PURE__*/React.createElement("g", {
  id: "TX04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "98.3,243.8 98.3,240.4 101.3,238.7 104.2,240.4 104.2,243.8 101.3,245.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M101.3,239.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L101.3,239.3 M101.3,238.1l-3.4,2v4l3.4,2l3.4-2v-4 L101.3,238.1L101.3,238.1z"
}));

var _ref29 = /*#__PURE__*/React.createElement("g", {
  id: "TX28"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "91.2,268.4 91.2,265 94.2,263.3 97.1,265 97.1,268.4 94.2,270.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M94.2,263.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L94.2,263.9 M94.2,262.8l-3.4,2v4l3.4,2l3.4-2v-4L94.2,262.8 L94.2,262.8z"
}));

var _ref30 = /*#__PURE__*/React.createElement("g", {
  id: "TX01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "87.6,237.7 87.6,234.3 90.6,232.6 93.5,234.3 93.5,237.7 90.6,239.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M90.6,233.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L90.6,233.2 M90.6,232l-3.4,2v4l3.4,2l3.4-2v-4L90.6,232 L90.6,232z"
}));

var _ref31 = /*#__PURE__*/React.createElement("g", {
  id: "TX14"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "91.2,256.1 91.2,252.7 94.1,251 97.1,252.7 97.1,256.1 94.1,257.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M94.1,251.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V253L94.1,251.6 M94.1,250.4l-3.4,2v4l3.4,2l3.4-2v-4L94.1,250.4 L94.1,250.4z"
}));

var _ref32 = /*#__PURE__*/React.createElement("g", {
  id: "TX02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "94.8,237.7 94.8,234.3 97.7,232.6 100.6,234.3 100.6,237.7 97.7,239.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M97.7,233.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L97.7,233.2 M97.7,232l-3.4,2v4l3.4,2l3.4-2v-4L97.7,232 L97.7,232z"
}));

var _ref33 = /*#__PURE__*/React.createElement("g", {
  id: "TX08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "101.9,250 101.9,246.6 104.8,244.9 107.7,246.6 107.7,250 104.8,251.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M104.8,245.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L104.8,245.5 M104.8,244.3l-3.4,2v4l3.4,2l3.4-2v-4 L104.8,244.3L104.8,244.3z"
}));

var _ref34 = /*#__PURE__*/React.createElement("g", {
  id: "TX09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "109,250 109,246.6 111.9,244.9 114.8,246.6 114.8,250 111.9,251.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M111.9,245.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L111.9,245.5 M111.9,244.3l-3.4,2v4l3.4,2l3.4-2v-4 L111.9,244.3L111.9,244.3z"
}));

var _ref35 = /*#__PURE__*/React.createElement("g", {
  id: "TX03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "91.2,243.8 91.2,240.4 94.2,238.7 97.1,240.4 97.1,243.8 94.2,245.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M94.2,239.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L94.2,239.3 M94.2,238.1l-3.4,2v4l3.4,2l3.4-2v-4L94.2,238.1 L94.2,238.1z"
}));

var _ref36 = /*#__PURE__*/React.createElement("g", {
  id: "TX06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "87.7,250 87.7,246.6 90.6,244.9 93.5,246.6 93.5,250 90.6,251.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M90.6,245.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L90.6,245.5 M90.6,244.3l-3.4,2v4l3.4,2l3.4-2v-4L90.6,244.3 L90.6,244.3z"
}));

var _ref37 = /*#__PURE__*/React.createElement("g", {
  id: "TX10"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "116.1,250 116.1,246.6 119,244.9 121.9,246.6 121.9,250 119,251.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M119,245.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L119,245.5 M119,244.3l-3.4,2v4l3.4,2l3.4-2v-4L119,244.3 L119,244.3z"
}));

var _ref38 = /*#__PURE__*/React.createElement("g", {
  id: "TX11"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "123.2,250 123.2,246.6 126.1,244.9 129,246.6 129,250 126.1,251.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M126.1,245.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L126.1,245.5 M126.1,244.3l-3.4,2v4l3.4,2l3.4-2v-4 L126.1,244.3L126.1,244.3z"
}));

var _ref39 = /*#__PURE__*/React.createElement("g", {
  id: "OK01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "102.5,230 102.5,226.6 105.4,224.9 108.4,226.6 108.4,230 105.4,231.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M105.4,225.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L105.4,225.5 M105.4,224.4l-3.4,2v4l3.4,2l3.4-2v-4 L105.4,224.4L105.4,224.4z"
}));

var _ref40 = /*#__PURE__*/React.createElement("g", {
  id: "OK02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "109.6,230 109.6,226.6 112.5,224.9 115.4,226.6 115.4,230 112.5,231.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M112.5,225.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L112.5,225.5 M112.5,224.4l-3.4,2v4l3.4,2l3.4-2v-4 L112.5,224.4L112.5,224.4z"
}));

var _ref41 = /*#__PURE__*/React.createElement("g", {
  id: "OK03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "116.6,230 116.6,226.6 119.6,224.9 122.5,226.6 122.5,230 119.6,231.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M119.6,225.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L119.6,225.5 M119.6,224.4l-3.4,2v4l3.4,2l3.4-2v-4 L119.6,224.4L119.6,224.4z"
}));

var _ref42 = /*#__PURE__*/React.createElement("g", {
  id: "OK04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "113.1,236.1 113.1,232.7 116,231 119,232.7 119,236.1 116,237.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M116,231.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V233L116,231.6 M116,230.5l-3.4,2v4l3.4,2l3.4-2v-4L116,230.5 L116,230.5z"
}));

var _ref43 = /*#__PURE__*/React.createElement("g", {
  id: "OK05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "120.2,236.1 120.2,232.7 123.1,231 126.1,232.7 126.1,236.1 123.1,237.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M123.1,231.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V233L123.1,231.6 M123.1,230.5l-3.4,2v4l3.4,2l3.4-2v-4 L123.1,230.5L123.1,230.5z"
}));

var _ref44 = /*#__PURE__*/React.createElement("g", {
  id: "TX07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "94.8,250 94.8,246.6 97.7,244.9 100.6,246.6 100.6,250 97.7,251.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M97.7,245.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L97.7,245.5 M97.7,244.3l-3.4,2v4l3.4,2l3.4-2v-4L97.7,244.3 L97.7,244.3z"
}));

var _ref45 = /*#__PURE__*/React.createElement("g", {
  id: "TX05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "80.5,250 80.5,246.6 83.5,244.9 86.4,246.6 86.4,250 83.5,251.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M83.5,245.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L83.5,245.5 M83.5,244.3l-3.4,2v4l3.4,2l3.4-2v-4L83.5,244.3 L83.5,244.3z"
}));

var _ref46 = /*#__PURE__*/React.createElement("g", {
  id: "TX12"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "130.3,250 130.3,246.6 133.2,244.9 136.1,246.6 136.1,250 133.2,251.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M133.2,245.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L133.2,245.5 M133.2,244.3l-3.4,2v4l3.4,2l3.4-2v-4 L133.2,244.3L133.2,244.3z"
}));

var _ref47 = /*#__PURE__*/React.createElement("g", {
  id: "TX17"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "112.5,256.1 112.5,252.7 115.4,251 118.4,252.7 118.4,256.1 115.4,257.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M115.4,251.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V253L115.4,251.6 M115.4,250.4l-3.4,2v4l3.4,2l3.4-2v-4 L115.4,250.4L115.4,250.4z"
}));

var _ref48 = /*#__PURE__*/React.createElement("g", {
  id: "TX20"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "133.8,256.1 133.8,252.7 136.8,251 139.7,252.7 139.7,256.1 136.8,257.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M136.8,251.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V253L136.8,251.6 M136.8,250.4l-3.4,2v4l3.4,2l3.4-2v-4 L136.8,250.4L136.8,250.4z"
}));

var _ref49 = /*#__PURE__*/React.createElement("g", {
  id: "TX18"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "119.6,256.1 119.6,252.7 122.5,251 125.5,252.7 125.5,256.1 122.5,257.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M122.5,251.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V253L122.5,251.6 M122.5,250.4l-3.4,2v4l3.4,2l3.4-2v-4 L122.5,250.4L122.5,250.4z"
}));

var _ref50 = /*#__PURE__*/React.createElement("g", {
  id: "TX19"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "126.7,256.1 126.7,252.7 129.7,251 132.6,252.7 132.6,256.1 129.7,257.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M129.7,251.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V253L129.7,251.6 M129.7,250.4l-3.4,2v4l3.4,2l3.4-2v-4 L129.7,250.4L129.7,250.4z"
}));

var _ref51 = /*#__PURE__*/React.createElement("g", {
  id: "TX25"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "116.1,262.3 116.1,258.9 119,257.2 122,258.9 122,262.3 119,264  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M119,257.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L119,257.7 M119,256.6l-3.4,2v4l3.4,2l3.4-2v-4L119,256.6 L119,256.6z"
}));

var _ref52 = /*#__PURE__*/React.createElement("g", {
  id: "TX26"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "123.2,262.3 123.2,258.9 126.1,257.2 129,258.9 129,262.3 126.1,264  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M126.1,257.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L126.1,257.7 M126.1,256.6l-3.4,2v4l3.4,2l3.4-2v-4 L126.1,256.6L126.1,256.6z"
}));

var _ref53 = /*#__PURE__*/React.createElement("g", {
  id: "TX27"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "130.3,262.3 130.3,258.9 133.2,257.2 136.1,258.9 136.1,262.3 133.2,264  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M133.2,257.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L133.2,257.7 M133.2,256.6l-3.4,2v4l3.4,2l3.4-2v-4 L133.2,256.6L133.2,256.6z"
}));

var _ref54 = /*#__PURE__*/React.createElement("g", {
  id: "TX30"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "112.5,268.4 112.5,265 115.5,263.3 118.4,265 118.4,268.4 115.5,270.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M115.5,263.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L115.5,263.9 M115.5,262.8l-3.4,2v4l3.4,2l3.4-2v-4 L115.5,262.8L115.5,262.8z"
}));

var _ref55 = /*#__PURE__*/React.createElement("g", {
  id: "TX31"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "119.6,268.4 119.6,265 122.5,263.3 125.5,265 125.5,268.4 122.5,270.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M122.5,263.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L122.5,263.9 M122.5,262.8l-3.4,2v4l3.4,2l3.4-2v-4 L122.5,262.8L122.5,262.8z"
}));

var _ref56 = /*#__PURE__*/React.createElement("g", {
  id: "TX32"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "126.7,268.4 126.7,265 129.6,263.3 132.6,265 132.6,268.4 129.6,270.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M129.6,263.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L129.6,263.9 M129.6,262.8l-3.4,2v4l3.4,2l3.4-2v-4 L129.6,262.8L129.6,262.8z"
}));

var _ref57 = /*#__PURE__*/React.createElement("g", {
  id: "TX33"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "116.1,274.6 116.1,271.2 119,269.5 121.9,271.2 121.9,274.6 119,276.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M119,270.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L119,270.1 M119,268.9l-3.4,2v4l3.4,2l3.4-2v-4L119,268.9 L119,268.9z"
}));

var _ref58 = /*#__PURE__*/React.createElement("g", {
  id: "TX34"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "123.2,274.6 123.2,271.2 126.1,269.5 129,271.2 129,274.6 126.1,276.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M126.1,270.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L126.1,270.1 M126.1,268.9l-3.4,2v4l3.4,2l3.4-2v-4 L126.1,268.9L126.1,268.9z"
}));

var _ref59 = /*#__PURE__*/React.createElement("g", {
  id: "TX35"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "119.6,280.7 119.6,277.3 122.6,275.6 125.5,277.3 125.5,280.7 122.6,282.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M122.6,276.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L122.6,276.2 M122.6,275l-3.4,2v4l3.4,2l3.4-2v-4L122.6,275 L122.6,275z"
}));

var _ref60 = /*#__PURE__*/React.createElement("g", {
  id: "TX15"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "98.3,256.1 98.3,252.7 101.2,251 104.2,252.7 104.2,256.1 101.2,257.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M101.2,251.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V253L101.2,251.6 M101.2,250.4l-3.4,2v4l3.4,2l3.4-2v-4 L101.2,250.4L101.2,250.4z"
}));

var _ref61 = /*#__PURE__*/React.createElement("g", {
  id: "MS04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "170.2,250 170.2,246.6 173.1,244.9 176.1,246.6 176.1,250 173.1,251.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M173.1,245.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L173.1,245.5 M173.1,244.3l-3.4,2v4l3.4,2l3.4-2v-4 L173.1,244.3L173.1,244.3z"
}));

var _ref62 = /*#__PURE__*/React.createElement("g", {
  id: "MS01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "170.2,237.8 170.2,234.4 173.1,232.7 176.1,234.4 176.1,237.8 173.1,239.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M173.1,233.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L173.1,233.2 M173.1,232.1l-3.4,2v4l3.4,2l3.4-2v-4 L173.1,232.1L173.1,232.1z"
}));

var _ref63 = /*#__PURE__*/React.createElement("g", {
  id: "MS02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "166.6,243.9 166.6,240.5 169.5,238.8 172.5,240.5 172.5,243.9 169.5,245.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M169.5,239.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L169.5,239.4 M169.5,238.2l-3.4,2v4l3.4,2l3.4-2v-4 L169.5,238.2L169.5,238.2z"
}));

var _ref64 = /*#__PURE__*/React.createElement("g", {
  id: "MS03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "173.7,243.9 173.7,240.5 176.7,238.8 179.6,240.5 179.6,243.9 176.7,245.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M176.7,239.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L176.7,239.4 M176.7,238.2l-3.4,2v4l3.4,2l3.4-2v-4 L176.7,238.2L176.7,238.2z"
}));

var _ref65 = /*#__PURE__*/React.createElement("g", {
  id: "LA05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "148.4,250 148.4,246.6 151.4,244.9 154.3,246.6 154.3,250 151.4,251.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M151.4,245.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L151.4,245.5 M151.4,244.3l-3.4,2v4l3.4,2l3.4-2v-4 L151.4,244.3L151.4,244.3z"
}));

var _ref66 = /*#__PURE__*/React.createElement("g", {
  id: "LA06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "155.5,250 155.5,246.6 158.5,244.9 161.4,246.6 161.4,250 158.5,251.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M158.5,245.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L158.5,245.5 M158.5,244.3l-3.4,2v4l3.4,2l3.4-2v-4 L158.5,244.3L158.5,244.3z"
}));

var _ref67 = /*#__PURE__*/React.createElement("g", {
  id: "LA04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "141.3,249.9 141.3,246.6 144.2,244.9 147.2,246.6 147.2,249.9 144.2,251.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M144.2,245.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L144.2,245.4 M144.2,244.3l-3.4,2v4l3.4,2l3.4-2v-4 L144.2,244.3L144.2,244.3z"
}));

var _ref68 = /*#__PURE__*/React.createElement("g", {
  id: "LA03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "144.9,243.8 144.9,240.4 147.9,238.7 150.8,240.4 150.8,243.8 147.9,245.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M147.9,239.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L147.9,239.3 M147.9,238.2l-3.4,2v4l3.4,2l3.4-2v-4 L147.9,238.2L147.9,238.2z"
}));

var _ref69 = /*#__PURE__*/React.createElement("g", {
  id: "LA02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "148.5,237.7 148.5,234.3 151.4,232.6 154.4,234.3 154.4,237.7 151.4,239.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M151.4,233.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L151.4,233.2 M151.4,232l-3.4,2v4l3.4,2l3.4-2v-4L151.4,232 L151.4,232z"
}));

var _ref70 = /*#__PURE__*/React.createElement("g", {
  id: "LA01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "141.3,237.7 141.3,234.3 144.2,232.6 147.2,234.3 147.2,237.7 144.2,239.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M144.2,233.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L144.2,233.2 M144.2,232l-3.4,2v4l3.4,2l3.4-2v-4L144.2,232 L144.2,232z"
}));

var _ref71 = /*#__PURE__*/React.createElement("g", {
  id: "AR01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "144.6,219.5 144.6,216.1 147.6,214.4 150.5,216.1 150.5,219.5 147.6,221.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M147.6,215l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L147.6,215 M147.6,213.8l-3.4,2v4l3.4,2l3.4-2v-4L147.6,213.8 L147.6,213.8z"
}));

var _ref72 = /*#__PURE__*/React.createElement("g", {
  id: "AR03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "141.1,225.6 141.1,222.2 144.1,220.5 147,222.2 147,225.6 144.1,227.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M144.1,221.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L144.1,221.1 M144.1,219.9l-3.4,2v4l3.4,2l3.4-2v-4 L144.1,219.9L144.1,219.9z"
}));

var _ref73 = /*#__PURE__*/React.createElement("g", {
  id: "AR04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "148.2,225.6 148.2,222.2 151.2,220.5 154.1,222.2 154.1,225.6 151.2,227.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M151.2,221.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L151.2,221.1 M151.2,219.9l-3.4,2v4l3.4,2l3.4-2v-4 L151.2,219.9L151.2,219.9z"
}));

var _ref74 = /*#__PURE__*/React.createElement("g", {
  id: "AR02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "151.7,219.5 151.7,216.1 154.7,214.4 157.6,216.1 157.6,219.5 154.7,221.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M154.7,215l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L154.7,215 M154.7,213.8l-3.4,2v4l3.4,2l3.4-2v-4L154.7,213.8 L154.7,213.8z"
}));

var _ref75 = /*#__PURE__*/React.createElement("g", {
  id: "AL07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "184.8,250 184.8,246.6 187.8,244.9 190.7,246.6 190.7,250 187.8,251.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M187.8,245.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L187.8,245.5 M187.8,244.3l-3.4,2v4l3.4,2l3.4-2v-4 L187.8,244.3L187.8,244.3z"
}));

var _ref76 = /*#__PURE__*/React.createElement("g", {
  id: "AL05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "188.4,243.9 188.4,240.5 191.3,238.8 194.2,240.5 194.2,243.9 191.3,245.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M191.3,239.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L191.3,239.4 M191.3,238.2l-3.4,2v4l3.4,2l3.4-2v-4 L191.3,238.2L191.3,238.2z"
}));

var _ref77 = /*#__PURE__*/React.createElement("g", {
  id: "AL06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "195.5,243.9 195.5,240.5 198.4,238.8 201.4,240.5 201.4,243.9 198.4,245.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M198.4,239.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L198.4,239.4 M198.4,238.2l-3.4,2v4l3.4,2l3.4-2v-4 L198.4,238.2L198.4,238.2z"
}));

var _ref78 = /*#__PURE__*/React.createElement("g", {
  id: "AL03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "191.9,237.8 191.9,234.4 194.9,232.7 197.8,234.4 197.8,237.8 194.9,239.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M194.9,233.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L194.9,233.2 M194.9,232.1l-3.4,2v4l3.4,2l3.4-2v-4 L194.9,232.1L194.9,232.1z"
}));

var _ref79 = /*#__PURE__*/React.createElement("g", {
  id: "AL04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "199,237.8 199,234.4 202,232.7 204.9,234.4 204.9,237.8 202,239.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M202,233.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L202,233.2 M202,232.1l-3.4,2v4l3.4,2l3.4-2v-4L202,232.1 L202,232.1z"
}));

var _ref80 = /*#__PURE__*/React.createElement("g", {
  id: "AL01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "188.4,231.6 188.4,228.2 191.3,226.5 194.2,228.2 194.2,231.6 191.3,233.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M191.3,227.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L191.3,227.1 M191.3,225.9l-3.4,2v4l3.4,2l3.4-2v-4 L191.3,225.9L191.3,225.9z"
}));

var _ref81 = /*#__PURE__*/React.createElement("g", {
  id: "AL02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "195.5,231.6 195.5,228.2 198.4,226.5 201.4,228.2 201.4,231.6 198.4,233.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M198.4,227.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L198.4,227.1 M198.4,225.9l-3.4,2v4l3.4,2l3.4-2v-4 L198.4,225.9L198.4,225.9z"
}));

var _ref82 = /*#__PURE__*/React.createElement("g", {
  id: "GA10"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "224.5,244.1 224.5,240.7 227.5,239 230.4,240.7 230.4,244.1 227.5,245.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M227.5,239.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V241L227.5,239.5 M227.5,238.4l-3.4,2v4l3.4,2l3.4-2v-4 L227.5,238.4L227.5,238.4z"
}));

var _ref83 = /*#__PURE__*/React.createElement("g", {
  id: "GA11"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "231.7,244.1 231.7,240.7 234.6,239 237.6,240.7 237.6,244.1 234.6,245.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M234.6,239.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V241L234.6,239.5 M234.6,238.4l-3.4,2v4l3.4,2l3.4-2v-4 L234.6,238.4L234.6,238.4z"
}));

var _ref84 = /*#__PURE__*/React.createElement("g", {
  id: "GA07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "221,237.9 221,234.5 223.9,232.8 226.9,234.5 226.9,237.9 223.9,239.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M223.9,233.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L223.9,233.4 M223.9,232.3l-3.4,2v4l3.4,2l3.4-2v-4 L223.9,232.3L223.9,232.3z"
}));

var _ref85 = /*#__PURE__*/React.createElement("g", {
  id: "GA08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "228.1,237.9 228.1,234.5 231,232.8 234,234.5 234,237.9 231,239.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M231,233.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L231,233.4 M231,232.3l-3.4,2v4l3.4,2l3.4-2v-4L231,232.3 L231,232.3z"
}));

var _ref86 = /*#__PURE__*/React.createElement("g", {
  id: "GA04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "217.5,231.8 217.5,228.4 220.4,226.7 223.3,228.4 223.3,231.8 220.4,233.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M220.4,227.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L220.4,227.3 M220.4,226.1l-3.4,2v4l3.4,2l3.4-2v-4 L220.4,226.1L220.4,226.1z"
}));

var _ref87 = /*#__PURE__*/React.createElement("g", {
  id: "GA09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "217.5,244.1 217.5,240.7 220.4,239 223.3,240.7 223.3,244.1 220.4,245.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M220.4,239.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V241L220.4,239.6 M220.4,238.4l-3.4,2v4l3.4,2l3.4-2v-4 L220.4,238.4L220.4,238.4z"
}));

var _ref88 = /*#__PURE__*/React.createElement("g", {
  id: "GA13"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "221,250.2 221,246.8 223.9,245.1 226.9,246.8 226.9,250.2 223.9,251.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M223.9,245.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L223.9,245.7 M223.9,244.5l-3.4,2v4l3.4,2l3.4-2v-4 L223.9,244.5L223.9,244.5z"
}));

var _ref89 = /*#__PURE__*/React.createElement("g", {
  id: "GA14"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "228.1,250.2 228.1,246.8 231.1,245.1 234,246.8 234,250.2 231.1,251.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M231.1,245.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L231.1,245.7 M231.1,244.5l-3.4,2v4l3.4,2l3.4-2v-4 L231.1,244.5L231.1,244.5z"
}));

var _ref90 = /*#__PURE__*/React.createElement("g", {
  id: "GA12"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "213.9,250.2 213.9,246.8 216.9,245.1 219.8,246.8 219.8,250.2 216.9,251.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M216.9,245.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L216.9,245.7 M216.9,244.5l-3.4,2v4l3.4,2l3.4-2v-4 L216.9,244.5L216.9,244.5z"
}));

var _ref91 = /*#__PURE__*/React.createElement("g", {
  id: "GA06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "213.9,237.9 213.9,234.5 216.9,232.8 219.8,234.5 219.8,237.9 216.9,239.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M216.9,233.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L216.9,233.4 M216.9,232.3l-3.4,2v4l3.4,2l3.4-2v-4 L216.9,232.3L216.9,232.3z"
}));

var _ref92 = /*#__PURE__*/React.createElement("g", {
  id: "GA03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "210.3,231.8 210.3,228.4 213.3,226.7 216.2,228.4 216.2,231.8 213.3,233.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M213.3,227.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L213.3,227.3 M213.3,226.1l-3.4,2v4l3.4,2l3.4-2v-4 L213.3,226.1L213.3,226.1z"
}));

var _ref93 = /*#__PURE__*/React.createElement("g", {
  id: "GA05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "224.5,231.8 224.5,228.4 227.5,226.7 230.4,228.4 230.4,231.8 227.5,233.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M227.5,227.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L227.5,227.3 M227.5,226.1l-3.4,2v4l3.4,2l3.4-2v-4 L227.5,226.1L227.5,226.1z"
}));

var _ref94 = /*#__PURE__*/React.createElement("g", {
  id: "GA01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "213.9,225.7 213.9,222.3 216.8,220.6 219.7,222.3 219.7,225.7 216.8,227.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M216.8,221.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L216.8,221.2 M216.8,220l-3.4,2v4l3.4,2l3.4-2v-4L216.8,220 L216.8,220z"
}));

var _ref95 = /*#__PURE__*/React.createElement("g", {
  id: "GA02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "221,225.7 221,222.3 223.9,220.6 226.9,222.3 226.9,225.7 223.9,227.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M223.9,221.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L223.9,221.2 M223.9,220l-3.4,2v4l3.4,2l3.4-2v-4L223.9,220 L223.9,220z"
}));

var _ref96 = /*#__PURE__*/React.createElement("g", {
  id: "TN04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "198.6,213.3 198.6,209.9 201.5,208.2 204.5,209.9 204.5,213.3 201.5,215  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M201.5,208.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L201.5,208.8 M201.5,207.7l-3.4,2v4l3.4,2l3.4-2v-4 L201.5,207.7L201.5,207.7z"
}));

var _ref97 = /*#__PURE__*/React.createElement("g", {
  id: "TN05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "205.7,213.3 205.7,209.9 208.7,208.2 211.6,209.9 211.6,213.3 208.7,215  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M208.7,208.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L208.7,208.8 M208.7,207.7l-3.4,2v4l3.4,2l3.4-2v-4 L208.7,207.7L208.7,207.7z"
}));

var _ref98 = /*#__PURE__*/React.createElement("g", {
  id: "TN02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "184.3,213.3 184.3,209.9 187.3,208.2 190.2,209.9 190.2,213.3 187.3,215  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M187.3,208.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L187.3,208.8 M187.3,207.7l-3.4,2v4l3.4,2l3.4-2v-4 L187.3,207.7L187.3,207.7z"
}));

var _ref99 = /*#__PURE__*/React.createElement("g", {
  id: "TN01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "177.2,213.3 177.2,209.9 180.1,208.2 183.1,209.9 183.1,213.3 180.1,215  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M180.1,208.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L180.1,208.8 M180.1,207.7l-3.4,2v4l3.4,2l3.4-2v-4 L180.1,207.7L180.1,207.7z"
}));

var _ref100 = /*#__PURE__*/React.createElement("g", {
  id: "TN03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "191.5,213.3 191.5,209.9 194.4,208.2 197.3,209.9 197.3,213.3 194.4,215  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M194.4,208.8l2.4,1.4v2.8l-2.4,1.4L192,213v-2.8L194.4,208.8 M194.4,207.7l-3.4,2v4l3.4,2l3.4-2v-4 L194.4,207.7L194.4,207.7z"
}));

var _ref101 = /*#__PURE__*/React.createElement("g", {
  id: "TN09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "195,219.5 195,216.1 198,214.4 200.9,216.1 200.9,219.5 198,221.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M198,215l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L198,215 M198,213.8l-3.4,2v4l3.4,2l3.4-2v-4L198,213.8L198,213.8 z"
}));

var _ref102 = /*#__PURE__*/React.createElement("g", {
  id: "TN07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "180.8,219.5 180.8,216.1 183.7,214.4 186.6,216.1 186.6,219.5 183.7,221.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M183.7,215l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L183.7,215 M183.7,213.8l-3.4,2v4l3.4,2l3.4-2v-4L183.7,213.8 L183.7,213.8z"
}));

var _ref103 = /*#__PURE__*/React.createElement("g", {
  id: "TN06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "173.6,219.5 173.6,216.1 176.6,214.4 179.5,216.1 179.5,219.5 176.6,221.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M176.6,215l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L176.6,215 M176.6,213.8l-3.4,2v4l3.4,2l3.4-2v-4L176.6,213.8 L176.6,213.8z"
}));

var _ref104 = /*#__PURE__*/React.createElement("g", {
  id: "TN08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "187.9,219.5 187.9,216.1 190.8,214.4 193.8,216.1 193.8,219.5 190.8,221.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M190.8,215l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L190.8,215 M190.8,213.8l-3.4,2v4l3.4,2l3.4-2v-4L190.8,213.8 L190.8,213.8z"
}));

var _ref105 = /*#__PURE__*/React.createElement("g", {
  id: "KY02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "203.1,194.8 203.1,191.4 206.1,189.7 209,191.4 209,194.8 206.1,196.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M206.1,190.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L206.1,190.3 M206.1,189.2l-3.4,2v4l3.4,2l3.4-2v-4 L206.1,189.2L206.1,189.2z"
}));

var _ref106 = /*#__PURE__*/React.createElement("g", {
  id: "KY01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "196,194.8 196,191.4 199,189.7 201.9,191.4 201.9,194.8 199,196.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M199,190.3l2.4,1.4v2.8L199,196l-2.4-1.4v-2.8L199,190.3 M199,189.2l-3.4,2v4l3.4,2l3.4-2v-4L199,189.2 L199,189.2z"
}));

var _ref107 = /*#__PURE__*/React.createElement("g", {
  id: "NC12"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "256.5,213.3 256.5,209.9 259.5,208.2 262.4,209.9 262.4,213.3 259.5,215  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M259.5,208.8l2.4,1.4v2.8l-2.4,1.4L257,213v-2.8L259.5,208.8 M259.5,207.7l-3.4,2v4l3.4,2l3.4-2v-4 L259.5,207.7L259.5,207.7z"
}));

var _ref108 = /*#__PURE__*/React.createElement("g", {
  id: "NC13"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "263.7,213.3 263.7,209.9 266.6,208.2 269.5,209.9 269.5,213.3 266.6,215  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M266.6,208.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L266.6,208.8 M266.6,207.7l-3.4,2v4l3.4,2l3.4-2v-4 L266.6,207.7L266.6,207.7z"
}));

var _ref109 = /*#__PURE__*/React.createElement("g", {
  id: "NC10"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "260.1,207.1 260.1,203.7 263,202 266,203.7 266,207.1 263,208.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M263,202.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V204L263,202.6 M263,201.5l-3.4,2v4l3.4,2l3.4-2v-4L263,201.5 L263,201.5z"
}));

var _ref110 = /*#__PURE__*/React.createElement("g", {
  id: "NC11"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "267.2,207.1 267.2,203.7 270.2,202 273.1,203.7 273.1,207.1 270.2,208.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M270.2,202.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V204L270.2,202.6 M270.2,201.5l-3.4,2v4l3.4,2l3.4-2v-4 L270.2,201.5L270.2,201.5z"
}));

var _ref111 = /*#__PURE__*/React.createElement("g", {
  id: "NC08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "245.8,207.1 245.8,203.7 248.8,202 251.7,203.7 251.7,207.1 248.8,208.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M248.8,202.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V204L248.8,202.6 M248.8,201.5l-3.4,2v4l3.4,2l3.4-2v-4 L248.8,201.5L248.8,201.5z"
}));

var _ref112 = /*#__PURE__*/React.createElement("g", {
  id: "NC07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "238.7,207.1 238.7,203.7 241.6,202 244.6,203.7 244.6,207.1 241.6,208.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M241.6,202.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V204L241.6,202.6 M241.6,201.5l-3.4,2v4l3.4,2l3.4-2v-4 L241.6,201.5L241.6,201.5z"
}));

var _ref113 = /*#__PURE__*/React.createElement("g", {
  id: "NC09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "252.9,207.1 252.9,203.7 255.9,202 258.8,203.7 258.8,207.1 255.9,208.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M255.9,202.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V204L255.9,202.6 M255.9,201.5l-3.4,2v4l3.4,2l3.4-2v-4 L255.9,201.5L255.9,201.5z"
}));

var _ref114 = /*#__PURE__*/React.createElement("g", {
  id: "NC04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "256.5,201 256.5,197.6 259.4,195.9 262.4,197.6 262.4,201 259.4,202.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M259.4,196.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L259.4,196.4 M259.4,195.3l-3.4,2v4l3.4,2l3.4-2v-4 L259.4,195.3L259.4,195.3z"
}));

var _ref115 = /*#__PURE__*/React.createElement("g", {
  id: "NC05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "263.7,201 263.7,197.6 266.6,195.9 269.5,197.6 269.5,201 266.6,202.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M266.6,196.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L266.6,196.4 M266.6,195.3l-3.4,2v4l3.4,2l3.4-2v-4 L266.6,195.3L266.6,195.3z"
}));

var _ref116 = /*#__PURE__*/React.createElement("g", {
  id: "NC06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "270.8,201 270.8,197.6 273.7,195.9 276.7,197.6 276.7,201 273.7,202.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M273.7,196.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L273.7,196.4 M273.7,195.3l-3.4,2v4l3.4,2l3.4-2v-4 L273.7,195.3L273.7,195.3z"
}));

var _ref117 = /*#__PURE__*/React.createElement("g", {
  id: "NC02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "242.3,201 242.3,197.6 245.2,195.9 248.1,197.6 248.1,201 245.2,202.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M245.2,196.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L245.2,196.5 M245.2,195.3l-3.4,2v4l3.4,2l3.4-2v-4 L245.2,195.3L245.2,195.3z"
}));

var _ref118 = /*#__PURE__*/React.createElement("g", {
  id: "NC01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "235.1,201 235.1,197.6 238.1,195.9 241,197.6 241,201 238.1,202.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M238.1,196.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L238.1,196.5 M238.1,195.3l-3.4,2v4l3.4,2l3.4-2v-4 L238.1,195.3L238.1,195.3z"
}));

var _ref119 = /*#__PURE__*/React.createElement("g", {
  id: "NC03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "249.4,201 249.4,197.6 252.3,195.9 255.3,197.6 255.3,201 252.3,202.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M252.3,196.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L252.3,196.4 M252.3,195.3l-3.4,2v4l3.4,2l3.4-2v-4 L252.3,195.3L252.3,195.3z"
}));

var _ref120 = /*#__PURE__*/React.createElement("g", {
  id: "VA07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "244.7,190.2 244.7,186.8 247.7,185.1 250.6,186.8 250.6,190.2 247.7,191.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M247.7,185.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L247.7,185.7 M247.7,184.5l-3.4,2v4l3.4,2l3.4-2v-4 L247.7,184.5L247.7,184.5z"
}));

var _ref121 = /*#__PURE__*/React.createElement("g", {
  id: "VA06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "237.6,190.2 237.6,186.8 240.5,185.1 243.5,186.8 243.5,190.2 240.5,191.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M240.5,185.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L240.5,185.7 M240.5,184.5l-3.4,2v4l3.4,2l3.4-2v-4 L240.5,184.5L240.5,184.5z"
}));

var _ref122 = /*#__PURE__*/React.createElement("g", {
  id: "VA09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "259,190.2 259,186.8 261.9,185.1 264.9,186.8 264.9,190.2 261.9,191.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M261.9,185.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L261.9,185.7 M261.9,184.5l-3.4,2v4l3.4,2l3.4-2v-4 L261.9,184.5L261.9,184.5z"
}));

var _ref123 = /*#__PURE__*/React.createElement("g", {
  id: "VA10"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "266.1,190.2 266.1,186.8 269,185.1 272,186.8 272,190.2 269,191.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M269,185.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L269,185.7 M269,184.5l-3.4,2v4l3.4,2l3.4-2v-4L269,184.5 L269,184.5z"
}));

var _ref124 = /*#__PURE__*/React.createElement("g", {
  id: "VA11"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "273.2,190.2 273.2,186.8 276.2,185.1 279.1,186.8 279.1,190.2 276.2,191.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M276.2,185.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L276.2,185.7 M276.2,184.5l-3.4,2v4l3.4,2l3.4-2v-4 L276.2,184.5L276.2,184.5z"
}));

var _ref125 = /*#__PURE__*/React.createElement("g", {
  id: "VA08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "251.8,190.2 251.8,186.8 254.8,185.1 257.7,186.8 257.7,190.2 254.8,191.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M254.8,185.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L254.8,185.7 M254.8,184.5l-3.4,2v4l3.4,2l3.4-2v-4 L254.8,184.5L254.8,184.5z"
}));

var _ref126 = /*#__PURE__*/React.createElement("g", {
  id: "VA04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "262.5,184 262.5,180.6 265.5,178.9 268.4,180.6 268.4,184 265.5,185.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M265.5,179.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L265.5,179.5 M265.5,178.3l-3.4,2v4l3.4,2l3.4-2v-4 L265.5,178.3L265.5,178.3z"
}));

var _ref127 = /*#__PURE__*/React.createElement("g", {
  id: "VA05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "269.7,184 269.7,180.6 272.6,178.9 275.5,180.6 275.5,184 272.6,185.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M272.6,179.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L272.6,179.5 M272.6,178.3l-3.4,2v4l3.4,2l3.4-2v-4 L272.6,178.3L272.6,178.3z"
}));

var _ref128 = /*#__PURE__*/React.createElement("g", {
  id: "VA03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "255.4,184 255.4,180.6 258.3,178.9 261.3,180.6 261.3,184 258.3,185.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M258.3,179.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L258.3,179.5 M258.3,178.3l-3.4,2v4l3.4,2l3.4-2v-4 L258.3,178.3L258.3,178.3z"
}));

var _ref129 = /*#__PURE__*/React.createElement("g", {
  id: "VA02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "266.1,177.8 266.1,174.4 269,172.7 272,174.4 272,177.8 269,179.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M269,173.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L269,173.3 M269,172.2l-3.4,2v4l3.4,2l3.4-2v-4L269,172.2 L269,172.2z"
}));

var _ref130 = /*#__PURE__*/React.createElement("g", {
  id: "VA01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "258.9,177.8 258.9,174.4 261.9,172.7 264.8,174.4 264.8,177.8 261.9,179.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M261.9,173.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L261.9,173.3 M261.9,172.2l-3.4,2v4l3.4,2l3.4-2v-4 L261.9,172.2L261.9,172.2z"
}));

var _ref131 = /*#__PURE__*/React.createElement("g", {
  id: "WV02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "254.2,160.1 254.2,156.7 257.1,155 260.1,156.7 260.1,160.1 257.1,161.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M257.1,155.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L257.1,155.5 M257.1,154.4l-3.4,2v4l3.4,2l3.4-2v-4 L257.1,154.4L257.1,154.4z"
}));

var _ref132 = /*#__PURE__*/React.createElement("g", {
  id: "WV03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "243.6,166.2 243.6,162.8 246.5,161.1 249.5,162.8 249.5,166.2 246.5,167.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M246.5,161.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L246.5,161.7 M246.5,160.5l-3.4,2v4l3.4,2l3.4-2v-4 L246.5,160.5L246.5,160.5z"
}));

var _ref133 = /*#__PURE__*/React.createElement("g", {
  id: "WV01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "247.1,160.1 247.1,156.7 250.1,155 253,156.7 253,160.1 250.1,161.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M250.1,155.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L250.1,155.5 M250.1,154.4l-3.4,2v4l3.4,2l3.4-2v-4 L250.1,154.4L250.1,154.4z"
}));

var _ref134 = /*#__PURE__*/React.createElement("g", {
  id: "IN07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "191.7,181.4 191.7,178 194.7,176.3 197.6,178 197.6,181.4 194.7,183.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M194.7,176.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L194.7,176.9 M194.7,175.7l-3.4,2v4l3.4,2l3.4-2v-4 L194.7,175.7L194.7,175.7z"
}));

var _ref135 = /*#__PURE__*/React.createElement("g", {
  id: "IN06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "184.6,181.4 184.6,178 187.5,176.3 190.5,178 190.5,181.4 187.5,183.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M187.6,176.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L187.6,176.9 M187.6,175.7l-3.4,2v4l3.4,2l3.4-2v-4 L187.6,175.7L187.6,175.7z"
}));

var _ref136 = /*#__PURE__*/React.createElement("g", {
  id: "IN02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "191.7,169.1 191.7,165.7 194.7,164 197.6,165.7 197.6,169.1 194.7,170.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M194.7,164.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L194.7,164.5 M194.7,163.4l-3.4,2v4l3.4,2l3.4-2v-4 L194.7,163.4L194.7,163.4z"
}));

var _ref137 = /*#__PURE__*/React.createElement("g", {
  id: "IN01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "184.6,169.1 184.6,165.7 187.5,164 190.5,165.7 190.5,169.1 187.5,170.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M187.6,164.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L187.6,164.5 M187.6,163.4l-3.4,2v4l3.4,2l3.4-2v-4 L187.6,163.4L187.6,163.4z"
}));

var _ref138 = /*#__PURE__*/React.createElement("g", {
  id: "IN05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "195.3,175.2 195.3,171.8 198.3,170.1 201.2,171.8 201.2,175.2 198.3,176.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M198.3,170.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L198.3,170.7 M198.3,169.6l-3.4,2v4l3.4,2l3.4-2v-4 L198.3,169.6L198.3,169.6z"
}));

var _ref139 = /*#__PURE__*/React.createElement("g", {
  id: "IN04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "188.2,175.2 188.2,171.8 191.1,170.1 194.1,171.8 194.1,175.2 191.1,176.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M191.1,170.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L191.1,170.7 M191.1,169.6l-3.4,2v4l3.4,2l3.4-2v-4 L191.1,169.6L191.1,169.6z"
}));

var _ref140 = /*#__PURE__*/React.createElement("g", {
  id: "IN03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "181,175.2 181,171.8 184,170.1 186.9,171.8 186.9,175.2 184,176.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M184,170.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L184,170.7 M184,169.6l-3.4,2v4l3.4,2l3.4-2v-4L184,169.6 L184,169.6z"
}));

var _ref141 = /*#__PURE__*/React.createElement("g", {
  id: "IN09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "188.2,187.6 188.2,184.2 191.1,182.5 194.1,184.2 194.1,187.6 191.1,189.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M191.1,183.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L191.1,183.1 M191.1,181.9l-3.4,2v4l3.4,2l3.4-2v-4 L191.1,181.9L191.1,181.9z"
}));

var _ref142 = /*#__PURE__*/React.createElement("g", {
  id: "IN08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "181,187.6 181,184.2 184,182.5 186.9,184.2 186.9,187.6 184,189.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M184,183.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L184,183.1 M184,181.9l-3.4,2v4l3.4,2l3.4-2v-4L184,181.9 L184,181.9z"
}));

var _ref143 = /*#__PURE__*/React.createElement("g", {
  id: "IL05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "162.9,171.4 162.9,168 165.9,166.3 168.8,168 168.8,171.4 165.9,173.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M165.9,166.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L165.9,166.9 M165.9,165.7l-3.4,2v4l3.4,2l3.4-2v-4 L165.9,165.7L165.9,165.7z"
}));

var _ref144 = /*#__PURE__*/React.createElement("g", {
  id: "IL04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "155.8,171.4 155.8,168 158.7,166.3 161.6,168 161.6,171.4 158.7,173.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M158.7,166.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L158.7,166.9 M158.7,165.7l-3.4,2v4l3.4,2l3.4-2v-4 L158.7,165.7L158.7,165.7z"
}));

var _ref145 = /*#__PURE__*/React.createElement("g", {
  id: "IL06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "170.1,171.4 170.1,168 173.1,166.3 176,168 176,171.4 173.1,173.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M173.1,166.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L173.1,166.9 M173.1,165.7l-3.4,2v4l3.4,2l3.4-2v-4 L173.1,165.7L173.1,165.7z"
}));

var _ref146 = /*#__PURE__*/React.createElement("g", {
  id: "IL12"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "162.9,183.7 162.9,180.3 165.9,178.6 168.8,180.3 168.8,183.7 165.9,185.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M165.9,179.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L165.9,179.2 M165.9,178l-3.4,2v4l3.4,2l3.4-2v-4L165.9,178 L165.9,178z"
}));

var _ref147 = /*#__PURE__*/React.createElement("g", {
  id: "IL11"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "155.8,183.7 155.8,180.3 158.7,178.6 161.6,180.3 161.6,183.7 158.7,185.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M158.7,179.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L158.7,179.2 M158.7,178l-3.4,2v4l3.4,2l3.4-2v-4L158.7,178 L158.7,178z"
}));

var _ref148 = /*#__PURE__*/React.createElement("g", {
  id: "IL18"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "162.9,196 162.9,192.6 165.9,190.9 168.8,192.6 168.8,196 165.9,197.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M165.9,191.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L165.9,191.4 M165.9,190.3l-3.4,2v4l3.4,2l3.4-2v-4 L165.9,190.3L165.9,190.3z"
}));

var _ref149 = /*#__PURE__*/React.createElement("g", {
  id: "IL17"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "155.8,196 155.8,192.6 158.7,190.9 161.6,192.6 161.6,196 158.7,197.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M158.7,191.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L158.7,191.4 M158.7,190.3l-3.4,2v4l3.4,2l3.4-2v-4 L158.7,190.3L158.7,190.3z"
}));

var _ref150 = /*#__PURE__*/React.createElement("g", {
  id: "IL10"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "148.7,183.7 148.7,180.3 151.6,178.6 154.5,180.3 154.5,183.7 151.6,185.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M151.6,179.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L151.6,179.2 M151.6,178l-3.4,2v4l3.4,2l3.4-2v-4L151.6,178 L151.6,178z"
}));

var _ref151 = /*#__PURE__*/React.createElement("g", {
  id: "IL13"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "170,183.7 170,180.3 173,178.6 175.9,180.3 175.9,183.7 173,185.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M173,179.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L173,179.2 M173,178l-3.4,2v4l3.4,2l3.4-2v-4L173,178L173,178z"
}));

var _ref152 = /*#__PURE__*/React.createElement("g", {
  id: "IL03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "166.5,165.2 166.5,161.8 169.4,160.1 172.4,161.8 172.4,165.2 169.4,166.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M169.4,160.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L169.4,160.7 M169.4,159.6l-3.4,2v4l3.4,2l3.4-2v-4 L169.4,159.6L169.4,159.6z"
}));

var _ref153 = /*#__PURE__*/React.createElement("g", {
  id: "IL02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "159.3,165.2 159.3,161.8 162.3,160.1 165.2,161.8 165.2,165.2 162.3,166.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M162.3,160.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L162.3,160.7 M162.3,159.6l-3.4,2v4l3.4,2l3.4-2v-4 L162.3,159.6L162.3,159.6z"
}));

var _ref154 = /*#__PURE__*/React.createElement("g", {
  id: "IL01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "152.2,165.2 152.2,161.8 155.1,160.1 158.1,161.8 158.1,165.2 155.1,166.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M155.1,160.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L155.1,160.7 M155.1,159.6l-3.4,2v4l3.4,2l3.4-2v-4 L155.1,159.6L155.1,159.6z"
}));

var _ref155 = /*#__PURE__*/React.createElement("g", {
  id: "IL08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "159.3,177.5 159.3,174.1 162.3,172.4 165.2,174.1 165.2,177.5 162.3,179.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M162.3,173l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L162.3,173 M162.3,171.9l-3.4,2v4l3.4,2l3.4-2v-4L162.3,171.9 L162.3,171.9z"
}));

var _ref156 = /*#__PURE__*/React.createElement("g", {
  id: "IL09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "166.5,177.5 166.5,174.1 169.5,172.4 172.4,174.1 172.4,177.5 169.5,179.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M169.5,173l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L169.5,173 M169.5,171.9l-3.4,2v4l3.4,2l3.4-2v-4L169.5,171.9 L169.5,171.9z"
}));

var _ref157 = /*#__PURE__*/React.createElement("g", {
  id: "IL07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "152.2,177.5 152.2,174.2 155.1,172.5 158.1,174.2 158.1,177.5 155.1,179.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M155.1,173l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L155.1,173 M155.1,171.9l-3.4,2v4l3.4,2l3.4-2v-4L155.1,171.9 L155.1,171.9z"
}));

var _ref158 = /*#__PURE__*/React.createElement("g", {
  id: "IL15"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "159.3,189.8 159.3,186.4 162.3,184.7 165.2,186.4 165.2,189.8 162.3,191.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M162.3,185.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L162.3,185.3 M162.3,184.2l-3.4,2v4l3.4,2l3.4-2v-4 L162.3,184.2L162.3,184.2z"
}));

var _ref159 = /*#__PURE__*/React.createElement("g", {
  id: "IL16"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "166.5,189.8 166.5,186.4 169.4,184.7 172.4,186.4 172.4,189.8 169.4,191.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M169.4,185.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L169.4,185.3 M169.4,184.2l-3.4,2v4l3.4,2l3.4-2v-4 L169.4,184.2L169.4,184.2z"
}));

var _ref160 = /*#__PURE__*/React.createElement("g", {
  id: "IL14"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "152.2,189.8 152.2,186.4 155.2,184.7 158.1,186.4 158.1,189.8 155.2,191.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M155.2,185.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L155.2,185.3 M155.2,184.2l-3.4,2v4l3.4,2l3.4-2v-4 L155.2,184.2L155.2,184.2z"
}));

var _ref161 = /*#__PURE__*/React.createElement("g", {
  id: "MO02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "135,190 135,186.6 138,184.9 140.9,186.6 140.9,190 138,191.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M138,185.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L138,185.5 M138,184.3l-3.4,2v4l3.4,2l3.4-2v-4L138,184.3 L138,184.3z"
}));

var _ref162 = /*#__PURE__*/React.createElement("g", {
  id: "MO07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "142.2,202.4 142.2,199 145.1,197.3 148,199 148,202.4 145.1,204.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M145.1,197.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L145.1,197.9 M145.1,196.7l-3.4,2v4l3.4,2l3.4-2v-4 L145.1,196.7L145.1,196.7z"
}));

var _ref163 = /*#__PURE__*/React.createElement("g", {
  id: "MO05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "127.9,202.4 127.9,199 130.8,197.3 133.8,199 133.8,202.4 130.8,204.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M130.8,197.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L130.8,197.9 M130.8,196.7l-3.4,2v4l3.4,2l3.4-2v-4 L130.8,196.7L130.8,196.7z"
}));

var _ref164 = /*#__PURE__*/React.createElement("g", {
  id: "MO08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "145.7,208.5 145.7,205.1 148.6,203.4 151.6,205.1 151.6,208.5 148.6,210.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M148.6,204l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L148.6,204 M148.6,202.8l-3.4,2v4l3.4,2l3.4-2v-4L148.6,202.8 L148.6,202.8z"
}));

var _ref165 = /*#__PURE__*/React.createElement("g", {
  id: "MO06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "135.1,202.4 135.1,199 138,197.3 140.9,199 140.9,202.4 138,204.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M138,197.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L138,197.9 M138,196.7l-3.4,2v4l3.4,2l3.4-2v-4L138,196.7 L138,196.7z"
}));

var _ref166 = /*#__PURE__*/React.createElement("g", {
  id: "MO01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "127.9,190 127.9,186.6 130.9,184.9 133.8,186.6 133.8,190 130.9,191.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M130.9,185.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L130.9,185.5 M130.9,184.3l-3.4,2v4l3.4,2l3.4-2v-4 L130.9,184.3L130.9,184.3z"
}));

var _ref167 = /*#__PURE__*/React.createElement("g", {
  id: "MO04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "138.6,196.2 138.6,192.8 141.6,191.1 144.5,192.8 144.5,196.2 141.6,197.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M141.6,191.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L141.6,191.7 M141.6,190.5l-3.4,2v4l3.4,2l3.4-2v-4 L141.6,190.5L141.6,190.5z"
}));

var _ref168 = /*#__PURE__*/React.createElement("g", {
  id: "MO03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "131.5,196.2 131.5,192.8 134.4,191.1 137.3,192.8 137.3,196.2 134.4,197.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M134.4,191.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L134.4,191.7 M134.4,190.5l-3.4,2v4l3.4,2l3.4-2v-4 L134.4,190.5L134.4,190.5z"
}));

var _ref169 = /*#__PURE__*/React.createElement("g", {
  id: "SDAL"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "87.1,143.1 87.1,139.7 90.1,138 93,139.7 93,143.1 90.1,144.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M90.1,138.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V140L90.1,138.6 M90.1,137.4l-3.4,2v4l3.4,2l3.4-2v-4L90.1,137.4 L90.1,137.4z"
}));

var _ref170 = /*#__PURE__*/React.createElement("g", {
  id: "WYAL"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "69.3,143.1 69.3,139.7 72.2,138 75.2,139.7 75.2,143.1 72.2,144.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M72.2,138.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V140L72.2,138.6 M72.2,137.4l-3.4,2v4l3.4,2l3.4-2v-4L72.2,137.4 L72.2,137.4z"
}));

var _ref171 = /*#__PURE__*/React.createElement("g", {
  id: "NDAL"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "87.1,123.3 87.1,119.9 90.1,118.2 93,119.9 93,123.3 90.1,125  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M90.1,118.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L90.1,118.8 M90.1,117.7l-3.4,2v4l3.4,2l3.4-2v-4L90.1,117.7 L90.1,117.7z"
}));

var _ref172 = /*#__PURE__*/React.createElement("g", {
  id: "MTAL"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "69.3,123.3 69.3,119.9 72.2,118.2 75.2,119.9 75.2,123.3 72.2,125  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M72.2,118.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L72.2,118.8 M72.2,117.7l-3.4,2v4l3.4,2l3.4-2v-4L72.2,117.7 L72.2,117.7z"
}));

var _ref173 = /*#__PURE__*/React.createElement("g", {
  id: "NE02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "95,162.7 95,159.3 98,157.6 100.9,159.3 100.9,162.7 98,164.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M98,158.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L98,158.2 M98,157.1l-3.4,2v4l3.4,2l3.4-2v-4L98,157.1L98,157.1z "
}));

var _ref174 = /*#__PURE__*/React.createElement("g", {
  id: "NE01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "88,162.7 88,159.3 90.9,157.6 93.9,159.3 93.9,162.7 90.9,164.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M90.9,158.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L90.9,158.2 M90.9,157.1l-3.4,2v4l3.4,2l3.4-2v-4L90.9,157.1 L90.9,157.1z"
}));

var _ref175 = /*#__PURE__*/React.createElement("g", {
  id: "NE03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "98.5,168.9 98.5,165.5 101.5,163.8 104.4,165.5 104.4,168.9 101.5,170.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M101.5,164.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L101.5,164.4 M101.5,163.2l-3.4,2v4l3.4,2l3.4-2v-4 L101.5,163.2L101.5,163.2z"
}));

var _ref176 = /*#__PURE__*/React.createElement("g", {
  id: "IA02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "127.8,168.6 127.8,165.3 130.7,163.6 133.7,165.3 133.7,168.6 130.7,170.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M130.7,164.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L130.7,164.1 M130.7,163l-3.4,2v4l3.4,2l3.4-2v-4L130.7,163 L130.7,163z"
}));

var _ref177 = /*#__PURE__*/React.createElement("g", {
  id: "IA01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "120.7,168.6 120.7,165.3 123.6,163.6 126.6,165.3 126.6,168.6 123.6,170.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M123.6,164.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L123.6,164.1 M123.6,163l-3.4,2v4l3.4,2l3.4-2v-4L123.6,163 L123.6,163z"
}));

var _ref178 = /*#__PURE__*/React.createElement("g", {
  id: "IA04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "131.4,174.8 131.4,171.4 134.3,169.7 137.3,171.4 137.3,174.8 134.3,176.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M134.3,170.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L134.3,170.3 M134.3,169.2l-3.4,2v4l3.4,2l3.4-2v-4 L134.3,169.2L134.3,169.2z"
}));

var _ref179 = /*#__PURE__*/React.createElement("g", {
  id: "IA03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "124.2,174.8 124.2,171.4 127.2,169.7 130.1,171.4 130.1,174.8 127.2,176.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M127.2,170.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L127.2,170.3 M127.2,169.2l-3.4,2v4l3.4,2l3.4-2v-4 L127.2,169.2L127.2,169.2z"
}));

var _ref180 = /*#__PURE__*/React.createElement("g", {
  id: "DEAL"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "303,169.4 303,166 306,164.3 308.9,166 308.9,169.4 306,171.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M306,164.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L306,164.9 M306,163.7l-3.4,2v4l3.4,2l3.4-2v-4L306,163.7 L306,163.7z"
}));

var _ref181 = /*#__PURE__*/React.createElement("g", {
  id: "ME01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "349.6,53 349.6,49.6 352.5,47.9 355.5,49.6 355.5,53 352.5,54.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M352.5,48.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L352.5,48.5 M352.5,47.3l-3.4,2v4l3.4,2l3.4-2v-4L352.5,47.3 L352.5,47.3z"
}));

var _ref182 = /*#__PURE__*/React.createElement("g", {
  id: "ME02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "346,59.2 346,55.8 349,54.1 351.9,55.8 351.9,59.2 349,60.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M349,54.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V56L349,54.6 M349,53.5l-3.4,2v4l3.4,2l3.4-2v-4L349,53.5L349,53.5z"
}));

var _ref183 = /*#__PURE__*/React.createElement("g", {
  id: "MA04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "316.3,94.6 316.3,91.2 319.3,89.5 322.2,91.2 322.2,94.6 319.3,96.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M319.3,90.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L319.3,90.1 M319.3,88.9l-3.4,2v4l3.4,2l3.4-2v-4L319.3,88.9 L319.3,88.9z"
}));

var _ref184 = /*#__PURE__*/React.createElement("g", {
  id: "MA06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "330.5,94.6 330.5,91.2 333.4,89.5 336.4,91.2 336.4,94.6 333.4,96.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M333.4,90.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L333.4,90.1 M333.4,88.9l-3.4,2v4l3.4,2l3.4-2v-4L333.4,88.9 L333.4,88.9z"
}));

var _ref185 = /*#__PURE__*/React.createElement("g", {
  id: "MA05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "323.4,94.6 323.4,91.2 326.4,89.5 329.3,91.2 329.3,94.6 326.4,96.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M326.4,90.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L326.4,90.1 M326.4,88.9l-3.4,2v4l3.4,2l3.4-2v-4L326.4,88.9 L326.4,88.9z"
}));

var _ref186 = /*#__PURE__*/React.createElement("g", {
  id: "MA07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "337.6,94.6 337.6,91.2 340.5,89.5 343.5,91.2 343.5,94.6 340.5,96.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M340.5,90.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L340.5,90.1 M340.5,88.9l-3.4,2v4l3.4,2l3.4-2v-4L340.5,88.9 L340.5,88.9z"
}));

var _ref187 = /*#__PURE__*/React.createElement("g", {
  id: "MA02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "326.9,88.5 326.9,85.1 329.9,83.4 332.8,85.1 332.8,88.5 329.9,90.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M329.9,83.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L329.9,83.9 M329.9,82.8l-3.4,2v4l3.4,2l3.4-2v-4L329.9,82.8 L329.9,82.8z"
}));

var _ref188 = /*#__PURE__*/React.createElement("g", {
  id: "MA01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "319.9,88.5 319.9,85.1 322.8,83.4 325.8,85.1 325.8,88.5 322.8,90.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M322.8,84l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L322.8,84 M322.8,82.8l-3.4,2v4l3.4,2l3.4-2v-4L322.8,82.8 L322.8,82.8z"
}));

var _ref189 = /*#__PURE__*/React.createElement("g", {
  id: "MA03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "334,88.5 334,85.1 336.9,83.4 339.9,85.1 339.9,88.5 336.9,90.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M336.9,83.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L336.9,83.9 M336.9,82.8l-3.4,2v4l3.4,2l3.4-2v-4L336.9,82.8 L336.9,82.8z"
}));

var _ref190 = /*#__PURE__*/React.createElement("g", {
  id: "MA08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "341.1,100.8 341.1,97.4 344.1,95.7 347,97.4 347,100.8 344.1,102.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M344.1,96.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L344.1,96.2 M344.1,95.1l-3.4,2v4l3.4,2l3.4-2v-4L344.1,95.1 L344.1,95.1z"
}));

var _ref191 = /*#__PURE__*/React.createElement("g", {
  id: "MA09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "348.3,100.8 348.3,97.4 351.2,95.7 354.1,97.4 354.1,100.8 351.2,102.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M351.2,96.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L351.2,96.2 M351.2,95.1l-3.4,2v4l3.4,2l3.4-2v-4L351.2,95.1 L351.2,95.1z"
}));

var _ref192 = /*#__PURE__*/React.createElement("g", {
  id: "RI02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "341.1,112.8 341.1,109.4 344,107.7 347,109.4 347,112.8 344,114.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M344,108.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L344,108.3 M344,107.1l-3.4,2v4l3.4,2l3.4-2v-4L344,107.1 L344,107.1z"
}));

var _ref193 = /*#__PURE__*/React.createElement("g", {
  id: "RI01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "334,112.8 334,109.4 336.9,107.7 339.9,109.4 339.9,112.8 336.9,114.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M336.9,108.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L336.9,108.3 M336.9,107.1l-3.4,2v4l3.4,2l3.4-2v-4 L336.9,107.1L336.9,107.1z"
}));

var _ref194 = /*#__PURE__*/React.createElement("g", {
  id: "NJ01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "291.5,135.4 291.5,132 294.4,130.3 297.4,132 297.4,135.4 294.4,137.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M294.4,130.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L294.4,130.9 M294.4,129.7l-3.4,2v4l3.4,2l3.4-2v-4 L294.4,129.7L294.4,129.7z"
}));

var _ref195 = /*#__PURE__*/React.createElement("g", {
  id: "NJ02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "298.6,135.4 298.6,132 301.6,130.3 304.5,132 304.5,135.4 301.6,137  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M301.6,130.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L301.6,130.8 M301.6,129.7l-3.4,2v4l3.4,2l3.4-2v-4 L301.6,129.7L301.6,129.7z"
}));

var _ref196 = /*#__PURE__*/React.createElement("g", {
  id: "NJ06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "291.5,147.7 291.5,144.3 294.4,142.6 297.4,144.3 297.4,147.7 294.4,149.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M294.4,143.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L294.4,143.2 M294.4,142.1l-3.4,2v4l3.4,2l3.4-2v-4 L294.4,142.1L294.4,142.1z"
}));

var _ref197 = /*#__PURE__*/React.createElement("g", {
  id: "NJ07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "298.6,147.7 298.6,144.3 301.6,142.6 304.5,144.3 304.5,147.7 301.6,149.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M301.6,143.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L301.6,143.2 M301.6,142.1l-3.4,2v4l3.4,2l3.4-2v-4 L301.6,142.1L301.6,142.1z"
}));

var _ref198 = /*#__PURE__*/React.createElement("g", {
  id: "NJ08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "305.7,147.7 305.7,144.3 308.7,142.6 311.6,144.3 311.6,147.7 308.7,149.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M308.7,143.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L308.7,143.2 M308.7,142.1l-3.4,2v4l3.4,2l3.4-2v-4 L308.7,142.1L308.7,142.1z"
}));

var _ref199 = /*#__PURE__*/React.createElement("g", {
  id: "NJ11"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "298.6,160.1 298.6,156.7 301.6,155 304.5,156.7 304.5,160.1 301.6,161.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M301.6,155.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L301.6,155.5 M301.6,154.4l-3.4,2v4l3.4,2l3.4-2v-4 L301.6,154.4L301.6,154.4z"
}));

var _ref200 = /*#__PURE__*/React.createElement("g", {
  id: "NJ12"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "305.7,160.1 305.7,156.7 308.6,155 311.6,156.7 311.6,160.1 308.6,161.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M308.6,155.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L308.6,155.5 M308.6,154.4l-3.4,2v4l3.4,2l3.4-2v-4 L308.6,154.4L308.6,154.4z"
}));

var _ref201 = /*#__PURE__*/React.createElement("g", {
  id: "NJ03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "295,141.6 295,138.2 298,136.5 300.9,138.2 300.9,141.6 298,143.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M298,137l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L298,137 M298,135.9l-3.4,2v4l3.4,2l3.4-2v-4L298,135.9L298,135.9 z"
}));

var _ref202 = /*#__PURE__*/React.createElement("g", {
  id: "NJ04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "302.2,141.6 302.2,138.2 305.1,136.5 308.1,138.2 308.1,141.6 305.1,143.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M305.1,137l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L305.1,137 M305.1,135.9l-3.4,2v4l3.4,2l3.4-2v-4L305.1,135.9 L305.1,135.9z"
}));

var _ref203 = /*#__PURE__*/React.createElement("g", {
  id: "NJ09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "295.1,153.9 295.1,150.5 298,148.8 300.9,150.5 300.9,153.9 298,155.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M298,149.4l2.4,1.4v2.8L298,155l-2.4-1.4v-2.8L298,149.4 M298,148.2l-3.4,2v4l3.4,2l3.4-2v-4L298,148.2 L298,148.2z"
}));

var _ref204 = /*#__PURE__*/React.createElement("g", {
  id: "NJ10"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "302.2,153.9 302.2,150.5 305.1,148.8 308.1,150.5 308.1,153.9 305.1,155.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M305.1,149.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L305.1,149.4 M305.1,148.2l-3.4,2v4l3.4,2l3.4-2v-4 L305.1,148.2L305.1,148.2z"
}));

var _ref205 = /*#__PURE__*/React.createElement("g", {
  id: "NJ05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "309.3,141.6 309.3,138.2 312.2,136.5 315.2,138.2 315.2,141.6 312.2,143.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M312.2,137l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L312.2,137 M312.2,135.9l-3.4,2v4l3.4,2l3.4-2v-4L312.2,135.9 L312.2,135.9z"
}));

var _ref206 = /*#__PURE__*/React.createElement("g", {
  id: "CT04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "315.9,112.7 315.9,109.3 318.9,107.6 321.8,109.3 321.8,112.7 318.9,114.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M318.9,108.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L318.9,108.2 M318.9,107l-3.4,2v4l3.4,2l3.4-2v-4L318.9,107 L318.9,107z"
}));

var _ref207 = /*#__PURE__*/React.createElement("g", {
  id: "CT05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "323,112.7 323,109.3 325.9,107.6 328.9,109.3 328.9,112.7 325.9,114.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M325.9,108.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L325.9,108.2 M325.9,107l-3.4,2v4l3.4,2l3.4-2v-4L325.9,107 L325.9,107z"
}));

var _ref208 = /*#__PURE__*/React.createElement("g", {
  id: "CT01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "312.3,106.6 312.3,103.2 315.3,101.5 318.2,103.2 318.2,106.6 315.3,108.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M315.3,102.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L315.3,102.1 M315.3,100.9l-3.4,2v4l3.4,2l3.4-2v-4 L315.3,100.9L315.3,100.9z"
}));

var _ref209 = /*#__PURE__*/React.createElement("g", {
  id: "CT02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "319.4,106.6 319.4,103.2 322.4,101.5 325.3,103.2 325.3,106.6 322.4,108.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M322.4,102.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L322.4,102.1 M322.4,100.9l-3.4,2v4l3.4,2l3.4-2v-4 L322.4,100.9L322.4,100.9z"
}));

var _ref210 = /*#__PURE__*/React.createElement("g", {
  id: "CT03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "326.5,106.6 326.5,103.2 329.5,101.5 332.4,103.2 332.4,106.6 329.5,108.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M329.5,102.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L329.5,102.1 M329.5,100.9l-3.4,2v4l3.4,2l3.4-2v-4 L329.5,100.9L329.5,100.9z"
}));

var _ref211 = /*#__PURE__*/React.createElement("g", {
  id: "NH02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "335.3,77.9 335.3,74.5 338.2,72.8 341.1,74.5 341.1,77.9 338.2,79.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M338.2,73.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L338.2,73.4 M338.2,72.2l-3.4,2v4l3.4,2l3.4-2v-4L338.2,72.2 L338.2,72.2z"
}));

var _ref212 = /*#__PURE__*/React.createElement("g", {
  id: "NH01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "338.8,71.7 338.8,68.3 341.8,66.6 344.7,68.3 344.7,71.7 341.8,73.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M341.8,67.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L341.8,67.2 M341.8,66l-3.4,2v4l3.4,2l3.4-2v-4L341.8,66 L341.8,66z"
}));

var _ref213 = /*#__PURE__*/React.createElement("g", {
  id: "NY19"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "264.7,125.2 264.7,121.8 267.6,120.1 270.6,121.8 270.6,125.2 267.6,126.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M267.6,120.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V122L267.6,120.6 M267.6,119.5l-3.4,2v4l3.4,2l3.4-2v-4 L267.6,119.5L267.6,119.5z"
}));

var _ref214 = /*#__PURE__*/React.createElement("g", {
  id: "NY20"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "271.8,125.2 271.8,121.8 274.7,120.1 277.7,121.8 277.7,125.2 274.7,126.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M274.7,120.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V122L274.7,120.6 M274.7,119.5l-3.4,2v4l3.4,2l3.4-2v-4 L274.7,119.5L274.7,119.5z"
}));

var _ref215 = /*#__PURE__*/React.createElement("g", {
  id: "NY22"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "286,125.1 286,121.7 289,120 291.9,121.7 291.9,125.1 289,126.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M289,120.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V122L289,120.6 M289,119.5l-3.4,2v4l3.4,2l3.4-2v-4L289,119.5 L289,119.5z"
}));

var _ref216 = /*#__PURE__*/React.createElement("g", {
  id: "NY21"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "278.9,125.1 278.9,121.7 281.9,120 284.8,121.7 284.8,125.1 281.9,126.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M281.9,120.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V122L281.9,120.6 M281.9,119.5l-3.4,2v4l3.4,2l3.4-2v-4 L281.9,119.5L281.9,119.5z"
}));

var _ref217 = /*#__PURE__*/React.createElement("g", {
  id: "NY23"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "293.2,125.2 293.2,121.8 296.1,120.1 299.1,121.8 299.1,125.2 296.1,126.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M296.1,120.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V122L296.1,120.6 M296.1,119.5l-3.4,2v4l3.4,2l3.4-2v-4 L296.1,119.5L296.1,119.5z"
}));

var _ref218 = /*#__PURE__*/React.createElement("g", {
  id: "NY24"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "300.3,125.2 300.3,121.8 303.3,120.1 306.2,121.8 306.2,125.2 303.3,126.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M303.3,120.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V122L303.3,120.6 M303.3,119.5l-3.4,2v4l3.4,2l3.4-2v-4 L303.3,119.5L303.3,119.5z"
}));

var _ref219 = /*#__PURE__*/React.createElement("g", {
  id: "NY25"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "307.4,125.2 307.4,121.8 310.4,120.1 313.3,121.8 313.3,125.2 310.4,126.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M310.4,120.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V122L310.4,120.6 M310.4,119.5l-3.4,2v4l3.4,2l3.4-2v-4 L310.4,119.5L310.4,119.5z"
}));

var _ref220 = /*#__PURE__*/React.createElement("g", {
  id: "NY13"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "268.2,119 268.2,115.6 271.2,113.9 274.1,115.6 274.1,119 271.2,120.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M271.2,114.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L271.2,114.5 M271.2,113.3l-3.4,2v4l3.4,2l3.4-2v-4 L271.2,113.3L271.2,113.3z"
}));

var _ref221 = /*#__PURE__*/React.createElement("g", {
  id: "NY14"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "275.3,119 275.3,115.6 278.3,113.9 281.2,115.6 281.2,119 278.3,120.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M278.3,114.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L278.3,114.5 M278.3,113.3l-3.4,2v4l3.4,2l3.4-2v-4 L278.3,113.3L278.3,113.3z"
}));

var _ref222 = /*#__PURE__*/React.createElement("g", {
  id: "NY16"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "289.6,119 289.6,115.6 292.5,113.9 295.5,115.6 295.5,119 292.5,120.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M292.5,114.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L292.5,114.5 M292.5,113.3l-3.4,2v4l3.4,2l3.4-2v-4 L292.5,113.3L292.5,113.3z"
}));

var _ref223 = /*#__PURE__*/React.createElement("g", {
  id: "NY15"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "282.5,119 282.5,115.6 285.4,113.9 288.4,115.6 288.4,119 285.4,120.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M285.4,114.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L285.4,114.5 M285.4,113.3l-3.4,2v4l3.4,2l3.4-2v-4 L285.4,113.3L285.4,113.3z"
}));

var _ref224 = /*#__PURE__*/React.createElement("g", {
  id: "NY17"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "296.7,119 296.7,115.6 299.7,113.9 302.6,115.6 302.6,119 299.7,120.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M299.7,114.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L299.7,114.5 M299.7,113.3l-3.4,2v4l3.4,2l3.4-2v-4 L299.7,113.3L299.7,113.3z"
}));

var _ref225 = /*#__PURE__*/React.createElement("g", {
  id: "NY18"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "303.9,119 303.9,115.6 306.8,113.9 309.8,115.6 309.8,119 306.8,120.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M306.8,114.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L306.8,114.5 M306.8,113.3l-3.4,2v4l3.4,2l3.4-2v-4 L306.8,113.3L306.8,113.3z"
}));

var _ref226 = /*#__PURE__*/React.createElement("g", {
  id: "NY07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "264.7,112.8 264.7,109.4 267.7,107.7 270.6,109.4 270.6,112.8 267.7,114.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M267.7,108.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L267.7,108.3 M267.7,107.1l-3.4,2v4l3.4,2l3.4-2v-4 L267.7,107.1L267.7,107.1z"
}));

var _ref227 = /*#__PURE__*/React.createElement("g", {
  id: "NY08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "271.8,112.8 271.8,109.4 274.7,107.7 277.7,109.4 277.7,112.8 274.7,114.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M274.7,108.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L274.7,108.3 M274.7,107.1l-3.4,2v4l3.4,2l3.4-2v-4 L274.7,107.1L274.7,107.1z"
}));

var _ref228 = /*#__PURE__*/React.createElement("g", {
  id: "NY10"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "286,112.8 286,109.4 289,107.7 291.9,109.4 291.9,112.8 289,114.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M289,108.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L289,108.3 M289,107.1l-3.4,2v4l3.4,2l3.4-2v-4L289,107.1 L289,107.1z"
}));

var _ref229 = /*#__PURE__*/React.createElement("g", {
  id: "NY09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "278.9,112.8 278.9,109.4 281.9,107.7 284.8,109.4 284.8,112.8 281.9,114.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M281.9,108.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L281.9,108.3 M281.9,107.1l-3.4,2v4l3.4,2l3.4-2v-4 L281.9,107.1L281.9,107.1z"
}));

var _ref230 = /*#__PURE__*/React.createElement("g", {
  id: "NY11"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "293.2,112.8 293.2,109.4 296.1,107.7 299.1,109.4 299.1,112.8 296.1,114.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M296.1,108.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L296.1,108.3 M296.1,107.1l-3.4,2v4l3.4,2l3.4-2v-4 L296.1,107.1L296.1,107.1z"
}));

var _ref231 = /*#__PURE__*/React.createElement("g", {
  id: "NY12"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "300.3,112.8 300.3,109.4 303.3,107.7 306.2,109.4 306.2,112.8 303.3,114.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M303.3,108.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L303.3,108.3 M303.3,107.1l-3.4,2v4l3.4,2l3.4-2v-4 L303.3,107.1L303.3,107.1z"
}));

var _ref232 = /*#__PURE__*/React.createElement("g", {
  id: "NY04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "282.5,106.6 282.5,103.2 285.4,101.5 288.4,103.2 288.4,106.6 285.4,108.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M285.4,102.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L285.4,102.1 M285.4,100.9l-3.4,2v4l3.4,2l3.4-2v-4 L285.4,100.9L285.4,100.9z"
}));

var _ref233 = /*#__PURE__*/React.createElement("g", {
  id: "NY05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "289.6,106.6 289.6,103.2 292.6,101.5 295.5,103.2 295.5,106.6 292.6,108.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M292.6,102.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L292.6,102.1 M292.6,100.9l-3.4,2v4l3.4,2l3.4-2v-4 L292.6,100.9L292.6,100.9z"
}));

var _ref234 = /*#__PURE__*/React.createElement("g", {
  id: "NY06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "296.7,106.6 296.7,103.2 299.7,101.5 302.6,103.2 302.6,106.6 299.7,108.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M299.7,102.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L299.7,102.1 M299.7,100.9l-3.4,2v4l3.4,2l3.4-2v-4 L299.7,100.9L299.7,100.9z"
}));

var _ref235 = /*#__PURE__*/React.createElement("g", {
  id: "NY26"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "311,131.3 311,127.9 314,126.2 316.9,127.9 316.9,131.3 314,133  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M314,126.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L314,126.8 M314,125.7l-3.4,2v4l3.4,2l3.4-2v-4L314,125.7 L314,125.7z"
}));

var _ref236 = /*#__PURE__*/React.createElement("g", {
  id: "NY27"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "318.2,131.4 318.2,128 321.1,126.3 324.1,128 324.1,131.4 321.1,133.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M321.1,126.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L321.1,126.8 M321.1,125.7l-3.4,2v4l3.4,2l3.4-2v-4 L321.1,125.7L321.1,125.7z"
}));

var _ref237 = /*#__PURE__*/React.createElement("g", {
  id: "NY01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "286,100.4 286,97 289,95.3 291.9,97 291.9,100.4 289,102.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M289,95.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L289,95.9 M289,94.7l-3.4,2v4l3.4,2l3.4-2v-4L289,94.7L289,94.7z "
}));

var _ref238 = /*#__PURE__*/React.createElement("g", {
  id: "NY02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "293.2,100.4 293.2,97 296.1,95.3 299.1,97 299.1,100.4 296.1,102.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M296.1,95.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L296.1,95.9 M296.1,94.8l-3.4,2v4l3.4,2l3.4-2v-4L296.1,94.8 L296.1,94.8z"
}));

var _ref239 = /*#__PURE__*/React.createElement("g", {
  id: "NY03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "300.3,100.4 300.3,97 303.3,95.3 306.2,97 306.2,100.4 303.3,102.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M303.3,95.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L303.3,95.9 M303.3,94.8l-3.4,2v4l3.4,2l3.4-2v-4L303.3,94.8 L303.3,94.8z"
}));

var _ref240 = /*#__PURE__*/React.createElement("g", {
  id: "VTAL"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "328.5,71.7 328.5,68.3 331.5,66.6 334.4,68.3 334.4,71.7 331.5,73.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M331.5,67.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L331.5,67.2 M331.5,66l-3.4,2v4l3.4,2l3.4-2v-4L331.5,66 L331.5,66z"
}));

var _ref241 = /*#__PURE__*/React.createElement("g", {
  id: "MD01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "271.4,170.1 271.4,166.7 274.4,165 277.3,166.7 277.3,170.1 274.4,171.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M274.4,165.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L274.4,165.5 M274.4,164.4l-3.4,2v4l3.4,2l3.4-2v-4 L274.4,164.4L274.4,164.4z"
}));

var _ref242 = /*#__PURE__*/React.createElement("g", {
  id: "MD03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "285.6,170.1 285.6,166.7 288.6,165 291.5,166.7 291.5,170.1 288.6,171.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M288.6,165.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L288.6,165.5 M288.6,164.4l-3.4,2v4l3.4,2l3.4-2v-4 L288.6,164.4L288.6,164.4z"
}));

var _ref243 = /*#__PURE__*/React.createElement("g", {
  id: "MD04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "292.8,170.1 292.8,166.7 295.7,165 298.7,166.7 298.7,170.1 295.7,171.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M295.7,165.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L295.7,165.5 M295.7,164.4l-3.4,2v4l3.4,2l3.4-2v-4 L295.7,164.4L295.7,164.4z"
}));

var _ref244 = /*#__PURE__*/React.createElement("g", {
  id: "MD02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "278.5,170.1 278.5,166.7 281.5,165 284.4,166.7 284.4,170.1 281.5,171.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M281.5,165.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L281.5,165.5 M281.5,164.4l-3.4,2v4l3.4,2l3.4-2v-4 L281.5,164.4L281.5,164.4z"
}));

var _ref245 = /*#__PURE__*/React.createElement("g", {
  id: "MD06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "289.2,176.2 289.2,172.8 292.2,171.1 295.1,172.8 295.1,176.2 292.2,177.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M292.2,171.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L292.2,171.7 M292.2,170.6l-3.4,2v4l3.4,2l3.4-2v-4 L292.2,170.6L292.2,170.6z"
}));

var _ref246 = /*#__PURE__*/React.createElement("g", {
  id: "MD07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "296.4,176.2 296.4,172.8 299.3,171.1 302.2,172.8 302.2,176.2 299.3,177.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M299.3,171.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L299.3,171.7 M299.3,170.6l-3.4,2v4l3.4,2l3.4-2v-4 L299.3,170.6L299.3,170.6z"
}));

var _ref247 = /*#__PURE__*/React.createElement("g", {
  id: "MD08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "300,182.4 300,179 302.9,177.3 305.8,179 305.8,182.4 302.9,184.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M302.9,177.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L302.9,177.9 M302.9,176.7l-3.4,2v4l3.4,2l3.4-2v-4 L302.9,176.7L302.9,176.7z"
}));

var _ref248 = /*#__PURE__*/React.createElement("g", {
  id: "MD05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "282.1,176.2 282.1,172.8 285,171.1 288,172.8 288,176.2 285,177.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M285,171.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L285,171.7 M285,170.5l-3.4,2v4l3.4,2l3.4-2v-4L285,170.5 L285,170.5z"
}));

var _ref249 = /*#__PURE__*/React.createElement("g", {
  id: "PA01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "243.1,137.5 243.1,134.1 246.1,132.4 249,134.1 249,137.5 246.1,139.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M246.1,133l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L246.1,133 M246.1,131.8l-3.4,2v4l3.4,2l3.4-2v-4L246.1,131.8 L246.1,131.8z"
}));

var _ref250 = /*#__PURE__*/React.createElement("g", {
  id: "PA02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "250.2,137.5 250.2,134.1 253.2,132.4 256.1,134.1 256.1,137.5 253.2,139.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M253.2,133l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L253.2,133 M253.2,131.8l-3.4,2v4l3.4,2l3.4-2v-4L253.2,131.8 L253.2,131.8z"
}));

var _ref251 = /*#__PURE__*/React.createElement("g", {
  id: "PA08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "246.7,143.7 246.7,140.3 249.6,138.6 252.6,140.3 252.6,143.7 249.6,145.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M249.6,139.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L249.6,139.2 M249.6,138l-3.4,2v4l3.4,2l3.4-2v-4L249.6,138 L249.6,138z"
}));

var _ref252 = /*#__PURE__*/React.createElement("g", {
  id: "PA09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "253.8,143.7 253.8,140.3 256.7,138.6 259.7,140.3 259.7,143.7 256.7,145.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M256.7,139.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L256.7,139.2 M256.7,138l-3.4,2v4l3.4,2l3.4-2v-4L256.7,138 L256.7,138z"
}));

var _ref253 = /*#__PURE__*/React.createElement("g", {
  id: "PA07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "239.5,143.7 239.5,140.3 242.5,138.6 245.4,140.3 245.4,143.7 242.5,145.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M242.5,139.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L242.5,139.2 M242.5,138l-3.4,2v4l3.4,2l3.4-2v-4L242.5,138 L242.5,138z"
}));

var _ref254 = /*#__PURE__*/React.createElement("g", {
  id: "PA14"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "250.2,149.9 250.2,146.5 253.2,144.8 256.1,146.5 256.1,149.9 253.2,151.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M253.2,145.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L253.2,145.4 M253.2,144.2l-3.4,2v4l3.4,2l3.4-2v-4 L253.2,144.2L253.2,144.2z"
}));

var _ref255 = /*#__PURE__*/React.createElement("g", {
  id: "PA13"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "243.1,149.9 243.1,146.5 246.1,144.8 249,146.5 249,149.9 246.1,151.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M246.1,145.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L246.1,145.4 M246.1,144.2l-3.4,2v4l3.4,2l3.4-2v-4 L246.1,144.2L246.1,144.2z"
}));

var _ref256 = /*#__PURE__*/React.createElement("g", {
  id: "PA04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "264.5,137.5 264.5,134.1 267.4,132.4 270.4,134.1 270.4,137.5 267.4,139.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M267.4,133l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L267.4,133 M267.4,131.8l-3.4,2v4l3.4,2l3.4-2v-4L267.4,131.8 L267.4,131.8z"
}));

var _ref257 = /*#__PURE__*/React.createElement("g", {
  id: "PA03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "257.4,137.5 257.4,134.1 260.3,132.4 263.2,134.1 263.2,137.5 260.3,139.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M260.3,133l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L260.3,133 M260.3,131.8l-3.4,2v4l3.4,2l3.4-2v-4L260.3,131.8 L260.3,131.8z"
}));

var _ref258 = /*#__PURE__*/React.createElement("g", {
  id: "PA05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "271.6,137.5 271.6,134.1 274.6,132.4 277.5,134.1 277.5,137.5 274.6,139.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M274.6,133l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L274.6,133 M274.6,131.8l-3.4,2v4l3.4,2l3.4-2v-4L274.6,131.8 L274.6,131.8z"
}));

var _ref259 = /*#__PURE__*/React.createElement("g", {
  id: "PA06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "278.7,137.5 278.7,134.1 281.7,132.4 284.6,134.1 284.6,137.5 281.7,139.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M281.7,133l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L281.7,133 M281.7,131.8l-3.4,2v4l3.4,2l3.4-2v-4L281.7,131.8 L281.7,131.8z"
}));

var _ref260 = /*#__PURE__*/React.createElement("g", {
  id: "PA11"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "268,143.7 268,140.3 271,138.6 273.9,140.3 273.9,143.7 271,145.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M271,139.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L271,139.2 M271,138l-3.4,2v4l3.4,2l3.4-2v-4L271,138L271,138z"
}));

var _ref261 = /*#__PURE__*/React.createElement("g", {
  id: "PA12"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "275.2,143.7 275.2,140.3 278.1,138.6 281.1,140.3 281.1,143.7 278.1,145.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M278.1,139.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L278.1,139.2 M278.1,138l-3.4,2v4l3.4,2l3.4-2v-4L278.1,138 L278.1,138z"
}));

var _ref262 = /*#__PURE__*/React.createElement("g", {
  id: "PA10"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "260.9,143.7 260.9,140.3 263.8,138.6 266.8,140.3 266.8,143.7 263.8,145.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M263.8,139.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L263.8,139.2 M263.8,138l-3.4,2v4l3.4,2l3.4-2v-4L263.8,138 L263.8,138z"
}));

var _ref263 = /*#__PURE__*/React.createElement("g", {
  id: "PA17"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "271.6,149.9 271.6,146.5 274.6,144.8 277.5,146.5 277.5,149.9 274.6,151.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M274.6,145.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L274.6,145.4 M274.6,144.2l-3.4,2v4l3.4,2l3.4-2v-4 L274.6,144.2L274.6,144.2z"
}));

var _ref264 = /*#__PURE__*/React.createElement("g", {
  id: "PA18"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "278.7,149.9 278.7,146.5 281.7,144.8 284.6,146.5 284.6,149.9 281.7,151.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M281.7,145.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L281.7,145.4 M281.7,144.2l-3.4,2v4l3.4,2l3.4-2v-4 L281.7,144.2L281.7,144.2z"
}));

var _ref265 = /*#__PURE__*/React.createElement("g", {
  id: "PA16"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "264.5,149.9 264.5,146.5 267.4,144.8 270.4,146.5 270.4,149.9 267.4,151.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M267.4,145.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L267.4,145.4 M267.4,144.2l-3.4,2v4l3.4,2l3.4-2v-4 L267.4,144.2L267.4,144.2z"
}));

var _ref266 = /*#__PURE__*/React.createElement("g", {
  id: "PA15"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "257.4,149.9 257.4,146.5 260.3,144.8 263.2,146.5 263.2,149.9 260.3,151.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M260.3,145.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L260.3,145.4 M260.3,144.2l-3.4,2v4l3.4,2l3.4-2v-4 L260.3,144.2L260.3,144.2z"
}));

var _ref267 = /*#__PURE__*/React.createElement("g", {
  id: "MI03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "192.6,123.3 192.6,119.9 195.5,118.2 198.5,119.9 198.5,123.3 195.5,125  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M195.5,118.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L195.5,118.8 M195.5,117.7l-3.4,2v4l3.4,2l3.4-2v-4 L195.5,117.7L195.5,117.7z"
}));

var _ref268 = /*#__PURE__*/React.createElement("g", {
  id: "MI04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "199.7,123.3 199.7,119.9 202.7,118.2 205.6,119.9 205.6,123.3 202.7,125  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M202.7,118.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L202.7,118.8 M202.7,117.7l-3.4,2v4l3.4,2l3.4-2v-4 L202.7,117.7L202.7,117.7z"
}));

var _ref269 = /*#__PURE__*/React.createElement("g", {
  id: "MI02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "185.5,123.3 185.5,119.9 188.4,118.2 191.3,119.9 191.3,123.3 188.4,125  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M188.4,118.8l2.4,1.4v2.8l-2.4,1.4L186,123v-2.8L188.4,118.8 M188.4,117.7l-3.4,2v4l3.4,2l3.4-2v-4 L188.4,117.7L188.4,117.7z"
}));

var _ref270 = /*#__PURE__*/React.createElement("g", {
  id: "MI07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "196.2,129.5 196.2,126.1 199.1,124.4 202,126.1 202,129.5 199.1,131.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M199.1,125l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L199.1,125 M199.1,123.8l-3.4,2v4l3.4,2l3.4-2v-4L199.1,123.8 L199.1,123.8z"
}));

var _ref271 = /*#__PURE__*/React.createElement("g", {
  id: "MI08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "203.3,129.5 203.3,126.1 206.2,124.4 209.2,126.1 209.2,129.5 206.2,131.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M206.2,125l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L206.2,125 M206.2,123.8l-3.4,2v4l3.4,2l3.4-2v-4L206.2,123.8 L206.2,123.8z"
}));

var _ref272 = /*#__PURE__*/React.createElement("g", {
  id: "MI06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "189,129.5 189,126.1 192,124.4 194.9,126.1 194.9,129.5 192,131.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M192,125l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L192,125 M192,123.8l-3.4,2v4l3.4,2l3.4-2v-4L192,123.8L192,123.8 z"
}));

var _ref273 = /*#__PURE__*/React.createElement("g", {
  id: "MI01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "177.4,118.2 177.4,114.8 180.4,113.1 183.3,114.8 183.3,118.2 180.4,119.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M180.4,113.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L180.4,113.7 M180.4,112.6l-3.4,2v4l3.4,2l3.4-2v-4 L180.4,112.6L180.4,112.6z"
}));

var _ref274 = /*#__PURE__*/React.createElement("g", {
  id: "MI05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "181.9,129.5 181.9,126.1 184.8,124.4 187.8,126.1 187.8,129.5 184.8,131.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M184.8,125l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L184.8,125 M184.8,123.8l-3.4,2v4l3.4,2l3.4-2v-4L184.8,123.8 L184.8,123.8z"
}));

var _ref275 = /*#__PURE__*/React.createElement("g", {
  id: "MI10"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "199.7,135.7 199.7,132.3 202.7,130.6 205.6,132.3 205.6,135.7 202.7,137.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M202.7,131.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L202.7,131.2 M202.7,130l-3.4,2v4l3.4,2l3.4-2v-4L202.7,130 L202.7,130z"
}));

var _ref276 = /*#__PURE__*/React.createElement("g", {
  id: "MI11"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "206.9,135.7 206.9,132.3 209.8,130.6 212.8,132.3 212.8,135.7 209.8,137.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M209.8,131.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L209.8,131.2 M209.8,130l-3.4,2v4l3.4,2l3.4-2v-4L209.8,130 L209.8,130z"
}));

var _ref277 = /*#__PURE__*/React.createElement("g", {
  id: "MI09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "192.6,135.7 192.6,132.3 195.5,130.6 198.5,132.3 198.5,135.7 195.5,137.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M195.5,131.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L195.5,131.2 M195.5,130l-3.4,2v4l3.4,2l3.4-2v-4L195.5,130 L195.5,130z"
}));

var _ref278 = /*#__PURE__*/React.createElement("g", {
  id: "MI14"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "203.3,141.9 203.3,138.5 206.2,136.8 209.2,138.5 209.2,141.9 206.2,143.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M206.2,137.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L206.2,137.4 M206.2,136.2l-3.4,2v4l3.4,2l3.4-2v-4 L206.2,136.2L206.2,136.2z"
}));

var _ref279 = /*#__PURE__*/React.createElement("g", {
  id: "MI13"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "196.2,141.9 196.2,138.5 199.1,136.8 202,138.5 202,141.9 199.1,143.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M199.1,137.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L199.1,137.4 M199.1,136.2l-3.4,2v4l3.4,2l3.4-2v-4 L199.1,136.2L199.1,136.2z"
}));

var _ref280 = /*#__PURE__*/React.createElement("g", {
  id: "MI12"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "189,141.9 189,138.5 192,136.8 194.9,138.5 194.9,141.9 192,143.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M192,137.4l2.4,1.4v2.8L192,143l-2.4-1.4v-2.8L192,137.4 M192,136.2l-3.4,2v4l3.4,2l3.4-2v-4L192,136.2 L192,136.2z"
}));

var _ref281 = /*#__PURE__*/React.createElement("g", {
  id: "WI01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "152.3,123.7 152.3,120.3 155.3,118.6 158.2,120.3 158.2,123.7 155.3,125.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M155.3,119.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L155.3,119.2 M155.3,118.1l-3.4,2v4l3.4,2l3.4-2v-4 L155.3,118.1L155.3,118.1z"
}));

var _ref282 = /*#__PURE__*/React.createElement("g", {
  id: "WI02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "159.5,123.7 159.5,120.3 162.4,118.6 165.4,120.3 165.4,123.7 162.4,125.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M162.4,119.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L162.4,119.2 M162.4,118.1l-3.4,2v4l3.4,2l3.4-2v-4 L162.4,118.1L162.4,118.1z"
}));

var _ref283 = /*#__PURE__*/React.createElement("g", {
  id: "WI04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "155.9,129.9 155.9,126.5 158.8,124.8 161.8,126.5 161.8,129.9 158.8,131.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M158.8,125.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L158.8,125.4 M158.8,124.3l-3.4,2v4l3.4,2l3.4-2v-4 L158.8,124.3L158.8,124.3z"
}));

var _ref284 = /*#__PURE__*/React.createElement("g", {
  id: "WI03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "148.8,129.9 148.8,126.5 151.7,124.8 154.7,126.5 154.7,129.9 151.7,131.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M151.7,125.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L151.7,125.4 M151.7,124.3l-3.4,2v4l3.4,2l3.4-2v-4 L151.7,124.3L151.7,124.3z"
}));

var _ref285 = /*#__PURE__*/React.createElement("g", {
  id: "WI05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "159.5,136.1 159.5,132.7 162.4,131 165.4,132.7 165.4,136.1 162.4,137.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M162.4,131.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V133L162.4,131.6 M162.4,130.4l-3.4,2v4l3.4,2l3.4-2v-4 L162.4,130.4L162.4,130.4z"
}));

var _ref286 = /*#__PURE__*/React.createElement("g", {
  id: "WI06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "166.6,136.1 166.6,132.7 169.6,131 172.5,132.7 172.5,136.1 169.6,137.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M169.6,131.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V133L169.6,131.6 M169.6,130.4l-3.4,2v4l3.4,2l3.4-2v-4 L169.6,130.4L169.6,130.4z"
}));

var _ref287 = /*#__PURE__*/React.createElement("g", {
  id: "WI08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "163,142.3 163,138.9 166,137.2 168.9,138.9 168.9,142.3 166,144  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M166,137.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L166,137.8 M166,136.6l-3.4,2v4l3.4,2l3.4-2v-4L166,136.6 L166,136.6z"
}));

var _ref288 = /*#__PURE__*/React.createElement("g", {
  id: "WI07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "155.9,142.3 155.9,138.9 158.8,137.2 161.8,138.9 161.8,142.3 158.8,144  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M158.8,137.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L158.8,137.8 M158.8,136.6l-3.4,2v4l3.4,2l3.4-2v-4 L158.8,136.6L158.8,136.6z"
}));

var _ref289 = /*#__PURE__*/React.createElement("g", {
  id: "MN02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "116.1,123.3 116.1,119.9 119,118.2 122,119.9 122,123.3 119,125  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M119,118.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L119,118.8 M119,117.7l-3.4,2v4l3.4,2l3.4-2v-4L119,117.7 L119,117.7z"
}));

var _ref290 = /*#__PURE__*/React.createElement("g", {
  id: "MN03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "123.2,123.3 123.2,119.9 126.2,118.2 129.1,119.9 129.1,123.3 126.2,125  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M126.2,118.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L126.2,118.8 M126.2,117.7l-3.4,2v4l3.4,2l3.4-2v-4 L126.2,117.7L126.2,117.7z"
}));

var _ref291 = /*#__PURE__*/React.createElement("g", {
  id: "MN01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "108.9,123.3 108.9,119.9 111.9,118.2 114.8,119.9 114.8,123.3 111.9,125  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M111.9,118.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L111.9,118.8 M111.9,117.7l-3.4,2v4l3.4,2l3.4-2v-4 L111.9,117.7L111.9,117.7z"
}));

var _ref292 = /*#__PURE__*/React.createElement("g", {
  id: "MN05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "119.7,129.5 119.7,126.1 122.6,124.4 125.5,126.1 125.5,129.5 122.6,131.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M122.6,125l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L122.6,125 M122.6,123.8l-3.4,2v4l3.4,2l3.4-2v-4L122.6,123.8 L122.6,123.8z"
}));

var _ref293 = /*#__PURE__*/React.createElement("g", {
  id: "MN04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "112.5,129.5 112.5,126.1 115.4,124.4 118.4,126.1 118.4,129.5 115.4,131.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M115.4,125l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L115.4,125 M115.4,123.8l-3.4,2v4l3.4,2l3.4-2v-4L115.4,123.8 L115.4,123.8z"
}));

var _ref294 = /*#__PURE__*/React.createElement("g", {
  id: "MN06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "116.1,135.7 116.1,132.3 119,130.6 122,132.3 122,135.7 119,137.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M119,131.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L119,131.2 M119,130l-3.4,2v4l3.4,2l3.4-2v-4L119,130L119,130z"
}));

var _ref295 = /*#__PURE__*/React.createElement("g", {
  id: "MN08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "119.7,141.9 119.7,138.5 122.6,136.8 125.5,138.5 125.5,141.9 122.6,143.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M122.6,137.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L122.6,137.4 M122.6,136.2l-3.4,2v4l3.4,2l3.4-2v-4 L122.6,136.2L122.6,136.2z"
}));

var _ref296 = /*#__PURE__*/React.createElement("g", {
  id: "MN07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "112.5,141.9 112.5,138.5 115.5,136.8 118.4,138.5 118.4,141.9 115.5,143.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M115.5,137.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L115.5,137.4 M115.5,136.2l-3.4,2v4l3.4,2l3.4-2v-4 L115.5,136.2L115.5,136.2z"
}));

var _ref297 = /*#__PURE__*/React.createElement("g", {
  id: "OH16"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "221.6,175.3 221.6,172 224.5,170.3 227.5,172 227.5,175.3 224.5,177  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M224.5,170.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L224.5,170.8 M224.5,169.7l-3.4,2v4l3.4,2l3.4-2v-4 L224.5,169.7L224.5,169.7z"
}));

var _ref298 = /*#__PURE__*/React.createElement("g", {
  id: "OH15"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "214.5,175.3 214.5,171.9 217.4,170.2 220.4,171.9 220.4,175.3 217.4,177  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M217.4,170.8l2.4,1.4v2.8l-2.4,1.4L215,175v-2.8L217.4,170.8 M217.4,169.7l-3.4,2v4l3.4,2l3.4-2v-4 L217.4,169.7L217.4,169.7z"
}));

var _ref299 = /*#__PURE__*/React.createElement("g", {
  id: "OH14"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "207.4,175.3 207.4,172 210.3,170.3 213.2,172 213.2,175.3 210.3,177  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M210.3,170.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L210.3,170.8 M210.3,169.7l-3.4,2v4l3.4,2l3.4-2v-4 L210.3,169.7L210.3,169.7z"
}));

var _ref300 = /*#__PURE__*/React.createElement("g", {
  id: "OH13"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "225.1,169.2 225.1,165.8 228.1,164.1 231,165.8 231,169.2 228.1,170.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M228.1,164.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L228.1,164.7 M228.1,163.5l-3.4,2v4l3.4,2l3.4-2v-4 L228.1,163.5L228.1,163.5z"
}));

var _ref301 = /*#__PURE__*/React.createElement("g", {
  id: "OH10"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "228.7,163.1 228.7,159.7 231.6,158 234.6,159.7 234.6,163.1 231.6,164.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M231.6,158.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L231.6,158.5 M231.6,157.4l-3.4,2v4l3.4,2l3.4-2v-4 L231.6,157.4L231.6,157.4z"
}));

var _ref302 = /*#__PURE__*/React.createElement("g", {
  id: "OH12"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "218,169.2 218,165.8 221,164.1 223.9,165.8 223.9,169.2 221,170.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M221,164.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L221,164.7 M221,163.5l-3.4,2v4l3.4,2l3.4-2v-4L221,163.5 L221,163.5z"
}));

var _ref303 = /*#__PURE__*/React.createElement("g", {
  id: "OH09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "221.6,163.1 221.6,159.7 224.5,158 227.5,159.7 227.5,163.1 224.5,164.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M224.5,158.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L224.5,158.5 M224.5,157.4l-3.4,2v4l3.4,2l3.4-2v-4 L224.5,157.4L224.5,157.4z"
}));

var _ref304 = /*#__PURE__*/React.createElement("g", {
  id: "OH05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "225.1,156.9 225.1,153.5 228.1,151.8 231,153.5 231,156.9 228.1,158.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M228.1,152.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L228.1,152.4 M228.1,151.2l-3.4,2v4l3.4,2l3.4-2v-4 L228.1,151.2L228.1,151.2z"
}));

var _ref305 = /*#__PURE__*/React.createElement("g", {
  id: "OH06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "232.3,156.9 232.3,153.5 235.2,151.8 238.1,153.5 238.1,156.9 235.2,158.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M235.2,152.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L235.2,152.4 M235.2,151.2l-3.4,2v4l3.4,2l3.4-2v-4 L235.2,151.2L235.2,151.2z"
}));

var _ref306 = /*#__PURE__*/React.createElement("g", {
  id: "OH11"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "210.9,169.2 210.9,165.8 213.8,164.1 216.8,165.8 216.8,169.2 213.8,170.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M213.8,164.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L213.8,164.7 M213.8,163.5l-3.4,2v4l3.4,2l3.4-2v-4 L213.8,163.5L213.8,163.5z"
}));

var _ref307 = /*#__PURE__*/React.createElement("g", {
  id: "OH08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "214.5,163.1 214.5,159.7 217.4,158 220.4,159.7 220.4,163.1 217.4,164.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M217.4,158.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L217.4,158.5 M217.4,157.4l-3.4,2v4l3.4,2l3.4-2v-4 L217.4,157.4L217.4,157.4z"
}));

var _ref308 = /*#__PURE__*/React.createElement("g", {
  id: "OH04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "218.1,156.9 218.1,153.5 221,151.8 223.9,153.5 223.9,156.9 221,158.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M221,152.4l2.4,1.4v2.8L221,158l-2.4-1.4v-2.8L221,152.4 M221,151.3l-3.4,2v4l3.4,2l3.4-2v-4L221,151.3 L221,151.3z"
}));

var _ref309 = /*#__PURE__*/React.createElement("g", {
  id: "OH02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "228.7,150.8 228.7,147.4 231.6,145.7 234.6,147.4 234.6,150.8 231.6,152.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M231.6,146.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L231.6,146.3 M231.6,145.1l-3.4,2v4l3.4,2l3.4-2v-4 L231.6,145.1L231.6,145.1z"
}));

var _ref310 = /*#__PURE__*/React.createElement("g", {
  id: "OH01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "221.6,150.8 221.6,147.4 224.5,145.7 227.5,147.4 227.5,150.8 224.5,152.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M224.5,146.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L224.5,146.3 M224.5,145.1l-3.4,2v4l3.4,2l3.4-2v-4 L224.5,145.1L224.5,145.1z"
}));

var _ref311 = /*#__PURE__*/React.createElement("g", {
  id: "OH07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "207.4,163.1 207.4,159.7 210.3,158 213.2,159.7 213.2,163.1 210.3,164.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M210.3,158.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L210.3,158.5 M210.3,157.4l-3.4,2v4l3.4,2l3.4-2v-4 L210.3,157.4L210.3,157.4z"
}));

var _ref312 = /*#__PURE__*/React.createElement("g", {
  id: "OH03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "210.9,156.9 210.9,153.5 213.8,151.8 216.8,153.5 216.8,156.9 213.8,158.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M213.8,152.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L213.8,152.4 M213.8,151.3l-3.4,2v4l3.4,2l3.4-2v-4 L213.8,151.3L213.8,151.3z"
}));

var _ref313 = /*#__PURE__*/React.createElement("g", {
  id: "KY06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "206.6,201 206.6,197.6 209.6,195.9 212.5,197.6 212.5,201 209.6,202.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M209.6,196.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L209.6,196.4 M209.6,195.3l-3.4,2v4l3.4,2l3.4-2v-4 L209.6,195.3L209.6,195.3z"
}));

var _ref314 = /*#__PURE__*/React.createElement("g", {
  id: "KY04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "192.5,201 192.5,197.6 195.4,195.9 198.4,197.6 198.4,201 195.4,202.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M195.4,196.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L195.4,196.4 M195.4,195.3l-3.4,2v4l3.4,2l3.4-2v-4 L195.4,195.3L195.4,195.3z"
}));

var _ref315 = /*#__PURE__*/React.createElement("g", {
  id: "KY03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "185.4,201 185.4,197.6 188.4,195.9 191.3,197.6 191.3,201 188.4,202.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M188.4,196.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L188.4,196.4 M188.4,195.3l-3.4,2v4l3.4,2l3.4-2v-4 L188.4,195.3L188.4,195.3z"
}));

var _ref316 = /*#__PURE__*/React.createElement("g", {
  id: "KY05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "199.6,201 199.6,197.6 202.5,195.9 205.5,197.6 205.5,201 202.5,202.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M202.5,196.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L202.5,196.4 M202.5,195.3l-3.4,2v4l3.4,2l3.4-2v-4 L202.5,195.3L202.5,195.3z"
}));

var _ref317 = /*#__PURE__*/React.createElement("g", {
  id: "SC01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "235.7,225.7 235.7,222.3 238.6,220.6 241.6,222.3 241.6,225.7 238.6,227.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M238.6,221.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L238.6,221.2 M238.6,220l-3.4,2v4l3.4,2l3.4-2v-4L238.6,220 L238.6,220z"
}));

var _ref318 = /*#__PURE__*/React.createElement("g", {
  id: "SC02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "242.8,225.7 242.8,222.3 245.7,220.6 248.6,222.3 248.6,225.7 245.7,227.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M245.7,221.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L245.7,221.2 M245.7,220l-3.4,2v4l3.4,2l3.4-2v-4L245.7,220 L245.7,220z"
}));

var _ref319 = /*#__PURE__*/React.createElement("g", {
  id: "SC03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "249.8,225.7 249.8,222.3 252.8,220.6 255.7,222.3 255.7,225.7 252.8,227.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M252.8,221.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L252.8,221.2 M252.8,220l-3.4,2v4l3.4,2l3.4-2v-4L252.8,220 L252.8,220z"
}));

var _ref320 = /*#__PURE__*/React.createElement("g", {
  id: "SC07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "249.8,237.9 249.8,234.5 252.8,232.8 255.7,234.5 255.7,237.9 252.8,239.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M252.8,233.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L252.8,233.4 M252.8,232.2l-3.4,2v4l3.4,2l3.4-2v-4 L252.8,232.2L252.8,232.2z"
}));

var _ref321 = /*#__PURE__*/React.createElement("g", {
  id: "SC05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "246.3,231.8 246.3,228.4 249.2,226.7 252.2,228.4 252.2,231.8 249.2,233.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M249.2,227.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L249.2,227.3 M249.2,226.1l-3.4,2v4l3.4,2l3.4-2v-4 L249.2,226.1L249.2,226.1z"
}));

var _ref322 = /*#__PURE__*/React.createElement("g", {
  id: "SC06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "253.4,231.8 253.4,228.4 256.3,226.7 259.3,228.4 259.3,231.8 256.3,233.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M256.3,227.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L256.3,227.3 M256.3,226.1l-3.4,2v4l3.4,2l3.4-2v-4 L256.3,226.1L256.3,226.1z"
}));

var _ref323 = /*#__PURE__*/React.createElement("g", {
  id: "SC04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "256.9,225.7 256.9,222.3 259.8,220.6 262.8,222.3 262.8,225.7 259.8,227.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M259.8,221.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L259.8,221.2 M259.8,220l-3.4,2v4l3.4,2l3.4-2v-4L259.8,220 L259.8,220z"
}));

var _ref324 = /*#__PURE__*/React.createElement("g", {
  id: "TX29"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "98.4,268.4 98.4,265 101.3,263.3 104.2,265 104.2,268.4 101.3,270.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M101.3,263.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L101.3,263.9 M101.3,262.8l-3.4,2v4l3.4,2l3.4-2v-4 L101.3,262.8L101.3,262.8z"
}));

var _ref325 = /*#__PURE__*/React.createElement("g", {
  id: "TX16"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "105.4,256.1 105.4,252.7 108.3,251 111.3,252.7 111.3,256.1 108.3,257.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M108.3,251.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V253L108.3,251.6 M108.3,250.4l-3.4,2v4l3.4,2l3.4-2v-4 L108.3,250.4L108.3,250.4z"
}));

var _ref326 = /*#__PURE__*/React.createElement("g", {
  id: "TX23"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "101.9,262.3 101.9,258.9 104.8,257.2 107.8,258.9 107.8,262.3 104.8,264  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M104.8,257.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L104.8,257.7 M104.8,256.6l-3.4,2v4l3.4,2l3.4-2v-4 L104.8,256.6L104.8,256.6z"
}));

var _ref327 = /*#__PURE__*/React.createElement("g", {
  id: "TX36"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "126.7,280.8 126.7,277.4 129.6,275.7 132.6,277.4 132.6,280.8 129.6,282.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M129.6,276.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L129.6,276.2 M129.6,275.1l-3.4,2v4l3.4,2l3.4-2v-4 L129.6,275.1L129.6,275.1z"
}));

var _ref328 = /*#__PURE__*/React.createElement("g", {
  id: "FL02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "202.2,263.7 202.2,260.3 205.1,258.6 208.1,260.3 208.1,263.7 205.1,265.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M205.1,259.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L205.1,259.1 M205.1,258l-3.4,2v4l3.4,2l3.4-2v-4L205.1,258 L205.1,258z"
}));

var _ref329 = /*#__PURE__*/React.createElement("g", {
  id: "FL01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "195.2,263.7 195.2,260.3 198.1,258.6 201.1,260.3 201.1,263.7 198.1,265.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M198.1,259.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L198.1,259.1 M198.1,258l-3.4,2v4l3.4,2l3.4-2v-4L198.1,258 L198.1,258z"
}));

var _ref330 = /*#__PURE__*/React.createElement("g", {
  id: "FL03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "209.3,263.7 209.3,260.3 212.2,258.6 215.2,260.3 215.2,263.7 212.2,265.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M212.2,259.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L212.2,259.1 M212.2,258l-3.4,2v4l3.4,2l3.4-2v-4L212.2,258 L212.2,258z"
}));

var _ref331 = /*#__PURE__*/React.createElement("g", {
  id: "FL09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "205.8,269.8 205.8,266.4 208.7,264.7 211.6,266.4 211.6,269.8 208.7,271.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M208.7,265.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L208.7,265.3 M208.7,264.1l-3.4,2v4l3.4,2l3.4-2v-4 L208.7,264.1L208.7,264.1z"
}));

var _ref332 = /*#__PURE__*/React.createElement("g", {
  id: "FL10"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "212.8,269.8 212.8,266.4 215.8,264.7 218.7,266.4 218.7,269.8 215.8,271.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M215.8,265.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L215.8,265.3 M215.8,264.1l-3.4,2v4l3.4,2l3.4-2v-4 L215.8,264.1L215.8,264.1z"
}));

var _ref333 = /*#__PURE__*/React.createElement("g", {
  id: "FL04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "216.4,263.7 216.4,260.3 219.3,258.6 222.3,260.3 222.3,263.7 219.3,265.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M219.3,259.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L219.3,259.1 M219.3,258l-3.4,2v4l3.4,2l3.4-2v-4L219.3,258 L219.3,258z"
}));

var _ref334 = /*#__PURE__*/React.createElement("g", {
  id: "FL05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "223.4,263.7 223.4,260.3 226.3,258.6 229.3,260.3 229.3,263.7 226.3,265.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M226.3,259.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L226.3,259.1 M226.3,258l-3.4,2v4l3.4,2l3.4-2v-4L226.3,258 L226.3,258z"
}));

var _ref335 = /*#__PURE__*/React.createElement("g", {
  id: "FL11"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "219.9,269.8 219.9,266.4 222.8,264.7 225.8,266.4 225.8,269.8 222.8,271.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M222.8,265.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L222.8,265.2 M222.8,264.1l-3.4,2v4l3.4,2l3.4-2v-4 L222.8,264.1L222.8,264.1z"
}));

var _ref336 = /*#__PURE__*/React.createElement("g", {
  id: "FL12"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "226.9,269.8 226.9,266.4 229.9,264.7 232.8,266.4 232.8,269.8 229.9,271.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M229.9,265.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L229.9,265.2 M229.9,264.1l-3.4,2v4l3.4,2l3.4-2v-4 L229.9,264.1L229.9,264.1z"
}));

var _ref337 = /*#__PURE__*/React.createElement("g", {
  id: "FL06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "230.4,263.7 230.4,260.3 233.4,258.6 236.3,260.3 236.3,263.7 233.4,265.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M233.4,259.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L233.4,259.1 M233.4,258l-3.4,2v4l3.4,2l3.4-2v-4L233.4,258 L233.4,258z"
}));

var _ref338 = /*#__PURE__*/React.createElement("g", {
  id: "FL07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "237.5,263.7 237.5,260.3 240.4,258.6 243.4,260.3 243.4,263.7 240.4,265.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M240.4,259.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L240.4,259.1 M240.4,258l-3.4,2v4l3.4,2l3.4-2v-4L240.4,258 L240.4,258z"
}));

var _ref339 = /*#__PURE__*/React.createElement("g", {
  id: "FL13"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "234,269.8 234,266.4 236.9,264.7 239.8,266.4 239.8,269.8 236.9,271.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M236.9,265.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L236.9,265.2 M236.9,264.1l-3.4,2v4l3.4,2l3.4-2v-4 L236.9,264.1L236.9,264.1z"
}));

var _ref340 = /*#__PURE__*/React.createElement("g", {
  id: "FL14"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "241,269.8 241,266.4 243.9,264.7 246.9,266.4 246.9,269.8 243.9,271.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M243.9,265.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L243.9,265.2 M243.9,264.1l-3.4,2v4l3.4,2l3.4-2v-4 L243.9,264.1L243.9,264.1z"
}));

var _ref341 = /*#__PURE__*/React.createElement("g", {
  id: "FL15"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "230.4,275.8 230.4,272.4 233.4,270.8 236.3,272.4 236.3,275.8 233.4,277.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M233.4,271.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L233.4,271.3 M233.4,270.2l-3.4,2v4l3.4,2l3.4-2v-4 L233.4,270.2L233.4,270.2z"
}));

var _ref342 = /*#__PURE__*/React.createElement("g", {
  id: "FL18"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "234,281.9 234,278.5 236.9,276.8 239.9,278.5 239.9,281.9 236.9,283.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M236.9,277.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L236.9,277.4 M236.9,276.3l-3.4,2v4l3.4,2l3.4-2v-4 L236.9,276.3L236.9,276.3z"
}));

var _ref343 = /*#__PURE__*/React.createElement("g", {
  id: "FL16"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "237.5,275.8 237.5,272.4 240.4,270.8 243.4,272.4 243.4,275.8 240.4,277.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M240.4,271.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L240.4,271.3 M240.4,270.2l-3.4,2v4l3.4,2l3.4-2v-4 L240.4,270.2L240.4,270.2z"
}));

var _ref344 = /*#__PURE__*/React.createElement("g", {
  id: "FL17"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "244.5,275.8 244.5,272.4 247.5,270.8 250.4,272.4 250.4,275.8 247.5,277.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M247.5,271.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L247.5,271.3 M247.5,270.2l-3.4,2v4l3.4,2l3.4-2v-4 L247.5,270.2L247.5,270.2z"
}));

var _ref345 = /*#__PURE__*/React.createElement("g", {
  id: "FL19"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "241,281.9 241,278.5 244,276.8 246.9,278.5 246.9,281.9 244,283.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M244,277.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L244,277.4 M244,276.3l-3.4,2v4l3.4,2l3.4-2v-4L244,276.3 L244,276.3z"
}));

var _ref346 = /*#__PURE__*/React.createElement("g", {
  id: "FL20"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "248.1,281.9 248.1,278.5 251,276.8 254,278.5 254,281.9 251,283.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M251,277.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L251,277.4 M251,276.3l-3.4,2v4l3.4,2l3.4-2v-4L251,276.3 L251,276.3z"
}));

var _ref347 = /*#__PURE__*/React.createElement("g", {
  id: "FL21"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "237.5,288 237.5,284.6 240.4,282.9 243.4,284.6 243.4,288 240.4,289.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M240.4,283.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L240.4,283.5 M240.4,282.4l-3.4,2v4l3.4,2l3.4-2v-4 L240.4,282.4L240.4,282.4z"
}));

var _ref348 = /*#__PURE__*/React.createElement("g", {
  id: "FL24"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "241,294.1 241,290.7 244,289 246.9,290.7 246.9,294.1 244,295.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M244,289.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V291L244,289.6 M244,288.4l-3.4,2v4l3.4,2l3.4-2v-4L244,288.4 L244,288.4z"
}));

var _ref349 = /*#__PURE__*/React.createElement("g", {
  id: "FL22"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "244.5,288 244.5,284.6 247.5,282.9 250.4,284.6 250.4,288 247.5,289.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M247.5,283.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L247.5,283.5 M247.5,282.4l-3.4,2v4l3.4,2l3.4-2v-4 L247.5,282.4L247.5,282.4z"
}));

var _ref350 = /*#__PURE__*/React.createElement("g", {
  id: "FL23"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "251.6,288 251.6,284.6 254.5,282.9 257.4,284.6 257.4,288 254.5,289.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M254.5,283.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L254.5,283.5 M254.5,282.4l-3.4,2v4l3.4,2l3.4-2v-4 L254.5,282.4L254.5,282.4z"
}));

var _ref351 = /*#__PURE__*/React.createElement("g", {
  id: "FL27"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "251.6,300.2 251.6,296.8 254.5,295.1 257.4,296.8 257.4,300.2 254.5,301.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M254.5,295.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L254.5,295.7 M254.5,294.5l-3.4,2v4l3.4,2l3.4-2v-4 L254.5,294.5L254.5,294.5z"
}));

var _ref352 = /*#__PURE__*/React.createElement("g", {
  id: "FL25"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "248.1,294.1 248.1,290.7 251,289 253.9,290.7 253.9,294.1 251,295.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M251,289.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V291L251,289.6 M251,288.4l-3.4,2v4l3.4,2l3.4-2v-4L251,288.4 L251,288.4z"
}));

var _ref353 = /*#__PURE__*/React.createElement("g", {
  id: "FL26"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "255.1,294.1 255.1,290.7 258,289 261,290.7 261,294.1 258,295.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M258,289.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V291L258,289.6 M258,288.4l-3.4,2v4l3.4,2l3.4-2v-4L258,288.4 L258,288.4z"
}));

var _ref354 = /*#__PURE__*/React.createElement("g", {
  id: "FL08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "198.7,269.8 198.7,266.4 201.6,264.7 204.6,266.4 204.6,269.8 201.6,271.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M201.6,265.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L201.6,265.3 M201.6,264.1l-3.4,2v4l3.4,2l3.4-2v-4 L201.6,264.1L201.6,264.1z"
}));

var _ref355 = /*#__PURE__*/React.createElement("g", {
  id: "TX13"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "84.1,256.1 84.1,252.7 87,251 89.9,252.7 89.9,256.1 87,257.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M87,251.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V253L87,251.6 M87,250.4l-3.4,2v4l3.4,2l3.4-2v-4L87,250.4L87,250.4z"
}));

var _ref356 = /*#__PURE__*/React.createElement("g", {
  id: "TX22"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "94.8,262.3 94.8,258.9 97.7,257.2 100.7,258.9 100.7,262.3 97.7,264  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M97.7,257.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L97.7,257.7 M97.7,256.6l-3.4,2v4l3.4,2l3.4-2v-4L97.7,256.6 L97.7,256.6z"
}));

var _ref357 = /*#__PURE__*/React.createElement("g", {
  id: "HI01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "75.4,289.1 75.4,285.7 78.4,284 81.3,285.7 81.3,289.1 78.4,290.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M78.4,284.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V286L78.4,284.6 M78.4,283.5l-3.4,2v4l3.4,2l3.4-2v-4L78.4,283.5 L78.4,283.5z"
}));

var _ref358 = /*#__PURE__*/React.createElement("g", {
  id: "AKAL"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "53.6,289.1 53.6,285.7 56.5,284 59.5,285.7 59.5,289.1 56.5,290.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M56.5,284.6L59,286v2.8l-2.4,1.4l-2.4-1.4V286L56.5,284.6 M56.5,283.5l-3.4,2v4l3.4,2l3.4-2v-4L56.5,283.5 L56.5,283.5z"
}));

var _ref359 = /*#__PURE__*/React.createElement("g", {
  id: "HI02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "79,295.2 79,291.8 81.9,290.1 84.9,291.8 84.9,295.2 81.9,296.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M81.9,290.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L81.9,290.7 M81.9,289.6l-3.4,2v4l3.4,2l3.4-2v-4L81.9,289.6 L81.9,289.6z"
}));

var _ref360 = /*#__PURE__*/React.createElement("g", {
  id: "TX24"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "109,262.3 109,258.9 111.9,257.2 114.9,258.9 114.9,262.3 111.9,264  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M111.9,257.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L111.9,257.7 M111.9,256.6l-3.4,2v4l3.4,2l3.4-2v-4 L111.9,256.6L111.9,256.6z"
}));

var _ref361 = /*#__PURE__*/React.createElement("g", {
  id: "NM02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "83.6,219.3 83.6,215.9 86.6,214.2 89.5,215.9 89.5,219.3 86.6,221  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M86.6,214.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L86.6,214.8 M86.6,213.7l-3.4,2v4l3.4,2l3.4-2v-4L86.6,213.7 L86.6,213.7z"
}));

var _ref362 = /*#__PURE__*/React.createElement("g", {
  id: "NM03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "80.1,225.4 80.1,222 83.1,220.3 86,222 86,225.4 83.1,227.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M83.1,220.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L83.1,220.9 M83.1,219.7l-3.4,2v4l3.4,2l3.4-2v-4L83.1,219.7 L83.1,219.7z"
}));

var _ref363 = /*#__PURE__*/React.createElement("g", {
  id: "NM01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "76.6,219.3 76.6,215.9 79.5,214.2 82.5,215.9 82.5,219.3 79.5,221  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M79.5,214.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L79.5,214.8 M79.5,213.7l-3.4,2v4l3.4,2l3.4-2v-4L79.5,213.7 L79.5,213.7z"
}));

var _ref364 = /*#__PURE__*/React.createElement("g", {
  id: "AZ02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "57.3,219.5 57.3,216.1 60.2,214.4 63.2,216.1 63.2,219.5 60.2,221.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M60.2,215l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L60.2,215 M60.2,213.8l-3.4,2v4l3.4,2l3.4-2v-4L60.2,213.8 L60.2,213.8z"
}));

var _ref365 = /*#__PURE__*/React.createElement("g", {
  id: "AZ01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "50.2,219.5 50.2,216.1 53.2,214.4 56.1,216.1 56.1,219.5 53.2,221.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M53.2,215l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L53.2,215 M53.2,213.8l-3.4,2v4l3.4,2l3.4-2v-4L53.2,213.8 L53.2,213.8z"
}));

var _ref366 = /*#__PURE__*/React.createElement("g", {
  id: "AZ03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "64.4,219.5 64.4,216.1 67.3,214.4 70.3,216.1 70.3,219.5 67.3,221.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M67.3,215l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L67.3,215 M67.3,213.8l-3.4,2v4l3.4,2l3.4-2v-4L67.3,213.8 L67.3,213.8z"
}));

var _ref367 = /*#__PURE__*/React.createElement("g", {
  id: "AZ05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "60.9,225.6 60.9,222.2 63.8,220.5 66.7,222.2 66.7,225.6 63.8,227.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M63.8,221.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L63.8,221.1 M63.8,219.9l-3.4,2v4l3.4,2l3.4-2v-4L63.8,219.9 L63.8,219.9z"
}));

var _ref368 = /*#__PURE__*/React.createElement("g", {
  id: "AZ04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "53.8,225.6 53.8,222.2 56.7,220.5 59.7,222.2 59.7,225.6 56.7,227.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M56.7,221.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L56.7,221.1 M56.7,219.9l-3.4,2v4l3.4,2l3.4-2v-4L56.7,219.9 L56.7,219.9z"
}));

var _ref369 = /*#__PURE__*/React.createElement("g", {
  id: "AZ06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "67.9,225.6 67.9,222.2 70.9,220.5 73.8,222.2 73.8,225.6 70.9,227.3  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M70.9,221.1l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L70.9,221.1 M70.9,219.9l-3.4,2v4l3.4,2l3.4-2v-4L70.9,219.9 L70.9,219.9z"
}));

var _ref370 = /*#__PURE__*/React.createElement("g", {
  id: "AZ08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "64.4,231.7 64.4,228.3 67.3,226.6 70.3,228.3 70.3,231.7 67.3,233.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M67.3,227.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L67.3,227.2 M67.3,226l-3.4,2v4l3.4,2l3.4-2v-4L67.3,226 L67.3,226z"
}));

var _ref371 = /*#__PURE__*/React.createElement("g", {
  id: "AZ07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "57.3,231.7 57.3,228.3 60.2,226.6 63.2,228.3 63.2,231.7 60.2,233.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M60.2,227.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L60.2,227.2 M60.2,226l-3.4,2v4l3.4,2l3.4-2v-4L60.2,226 L60.2,226z"
}));

var _ref372 = /*#__PURE__*/React.createElement("g", {
  id: "AZ09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "71.5,231.7 71.5,228.3 74.5,226.6 77.4,228.3 77.4,231.7 74.5,233.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M74.5,227.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L74.5,227.2 M74.5,226l-3.4,2v4l3.4,2l3.4-2v-4L74.5,226 L74.5,226z"
}));

var _ref373 = /*#__PURE__*/React.createElement("g", {
  id: "UT01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "59.7,194.4 59.7,191 62.7,189.3 65.6,191 65.6,194.4 62.7,196.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M62.7,189.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L62.7,189.9 M62.7,188.7l-3.4,2v4l3.4,2l3.4-2v-4L62.7,188.7 L62.7,188.7z"
}));

var _ref374 = /*#__PURE__*/React.createElement("g", {
  id: "UT04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "59.7,206.7 59.7,203.3 62.7,201.6 65.6,203.3 65.6,206.7 62.7,208.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M62.7,202.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L62.7,202.2 M62.7,201.1l-3.4,2v4l3.4,2l3.4-2v-4L62.7,201.1 L62.7,201.1z"
}));

var _ref375 = /*#__PURE__*/React.createElement("g", {
  id: "UT02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "56.1,200.5 56.1,197.2 59.1,195.5 62,197.2 62,200.5 59.1,202.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M59.1,196l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L59.1,196 M59.1,194.9l-3.4,2v4l3.4,2l3.4-2v-4L59.1,194.9 L59.1,194.9z"
}));

var _ref376 = /*#__PURE__*/React.createElement("g", {
  id: "UT03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "63.3,200.5 63.3,197.2 66.2,195.5 69.2,197.2 69.2,200.5 66.2,202.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M66.2,196l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L66.2,196 M66.2,194.9l-3.4,2v4l3.4,2l3.4-2v-4L66.2,194.9 L66.2,194.9z"
}));

var _ref377 = /*#__PURE__*/React.createElement("g", {
  id: "NV01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "35,194.4 35,191 38,189.3 40.9,191 40.9,194.4 38,196.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M38,189.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L38,189.9 M38,188.7l-3.4,2v4l3.4,2l3.4-2v-4L38,188.7L38,188.7z "
}));

var _ref378 = /*#__PURE__*/React.createElement("g", {
  id: "NV02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "42.2,194.4 42.2,191 45.1,189.3 48.1,191 48.1,194.4 45.1,196.1  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M45.1,189.9l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L45.1,189.9 M45.1,188.7l-3.4,2v4l3.4,2l3.4-2v-4L45.1,188.7 L45.1,188.7z"
}));

var _ref379 = /*#__PURE__*/React.createElement("g", {
  id: "NV03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "38.6,200.5 38.6,197.2 41.6,195.5 44.5,197.2 44.5,200.5 41.6,202.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M41.6,196l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L41.6,196 M41.6,194.9l-3.4,2v4l3.4,2l3.4-2v-4L41.6,194.9 L41.6,194.9z"
}));

var _ref380 = /*#__PURE__*/React.createElement("g", {
  id: "NV04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "45.8,200.5 45.8,197.2 48.7,195.5 51.6,197.2 51.6,200.5 48.7,202.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M48.7,196l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L48.7,196 M48.7,194.9l-3.4,2v4l3.4,2l3.4-2v-4L48.7,194.9 L48.7,194.9z"
}));

var _ref381 = /*#__PURE__*/React.createElement("g", {
  id: "KS01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "106.1,204 106.1,200.6 109.1,198.9 112,200.6 112,204 109.1,205.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M109.1,199.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L109.1,199.5 M109.1,198.3l-3.4,2v4l3.4,2l3.4-2v-4 L109.1,198.3L109.1,198.3z"
}));

var _ref382 = /*#__PURE__*/React.createElement("g", {
  id: "KS02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "113.3,204 113.3,200.6 116.2,198.9 119.2,200.6 119.2,204 116.2,205.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M116.2,199.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L116.2,199.5 M116.2,198.3l-3.4,2v4l3.4,2l3.4-2v-4 L116.2,198.3L116.2,198.3z"
}));

var _ref383 = /*#__PURE__*/React.createElement("g", {
  id: "KS03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "109.7,210.2 109.7,206.8 112.7,205.1 115.6,206.8 115.6,210.2 112.7,211.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M112.7,205.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L112.7,205.7 M112.7,204.5l-3.4,2v4l3.4,2l3.4-2v-4 L112.7,204.5L112.7,204.5z"
}));

var _ref384 = /*#__PURE__*/React.createElement("g", {
  id: "KS04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "116.8,210.2 116.8,206.8 119.8,205.1 122.7,206.8 122.7,210.2 119.8,211.9  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M119.8,205.7l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L119.8,205.7 M119.8,204.5l-3.4,2v4l3.4,2l3.4-2v-4 L119.8,204.5L119.8,204.5z"
}));

var _ref385 = /*#__PURE__*/React.createElement("g", {
  id: "CA01"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "2.8,175.8 2.8,172.4 5.7,170.7 8.6,172.4 8.6,175.8 5.7,177.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M5.7,171.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L5.7,171.3 M5.7,170.2l-3.4,2v4l3.4,2l3.4-2v-4L5.7,170.2 L5.7,170.2z"
}));

var _ref386 = /*#__PURE__*/React.createElement("g", {
  id: "CA05"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "6.3,182 6.3,178.6 9.3,176.9 12.2,178.6 12.2,182 9.3,183.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M9.3,177.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L9.3,177.5 M9.3,176.3l-3.4,2v4l3.4,2l3.4-2v-4L9.3,176.3 L9.3,176.3z"
}));

var _ref387 = /*#__PURE__*/React.createElement("g", {
  id: "CA06"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "13.5,182 13.5,178.6 16.4,176.9 19.4,178.6 19.4,182 16.4,183.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M16.4,177.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L16.4,177.5 M16.4,176.3l-3.4,2v4l3.4,2l3.4-2v-4L16.4,176.3 L16.4,176.3z"
}));

var _ref388 = /*#__PURE__*/React.createElement("g", {
  id: "CA07"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "20.6,182 20.6,178.6 23.6,176.9 26.5,178.6 26.5,182 23.6,183.7  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M23.6,177.5l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L23.6,177.5 M23.6,176.3l-3.4,2v4l3.4,2l3.4-2v-4L23.6,176.3 L23.6,176.3z"
}));

var _ref389 = /*#__PURE__*/React.createElement("g", {
  id: "CA02"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "9.9,175.8 9.9,172.4 12.9,170.7 15.8,172.4 15.8,175.8 12.9,177.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M12.9,171.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L12.9,171.3 M12.9,170.2l-3.4,2v4l3.4,2l3.4-2v-4L12.9,170.2 L12.9,170.2z"
}));

var _ref390 = /*#__PURE__*/React.createElement("g", {
  id: "CA03"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "17.1,175.8 17.1,172.4 20,170.7 22.9,172.4 22.9,175.8 20,177.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M20,171.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L20,171.3 M20,170.2l-3.4,2v4l3.4,2l3.4-2v-4L20,170.2L20,170.2z "
}));

var _ref391 = /*#__PURE__*/React.createElement("g", {
  id: "CA04"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "24.2,175.8 24.2,172.4 27.1,170.7 30.1,172.4 30.1,175.8 27.1,177.5  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M27.1,171.3l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L27.1,171.3 M27.1,170.2l-3.4,2v4l3.4,2l3.4-2v-4L27.1,170.2 L27.1,170.2z"
}));

var _ref392 = /*#__PURE__*/React.createElement("g", {
  id: "CA08"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "2.8,188.1 2.8,184.7 5.8,183 8.7,184.7 8.7,188.1 5.8,189.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M5.8,183.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V185L5.8,183.6 M5.8,182.5l-3.4,2v4l3.4,2l3.4-2v-4L5.8,182.5 L5.8,182.5z"
}));

var _ref393 = /*#__PURE__*/React.createElement("g", {
  id: "CA12"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "6.3,194.3 6.3,190.9 9.3,189.2 12.2,190.9 12.2,194.3 9.3,196  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M9.3,189.8l2.4,1.4v2.8l-2.4,1.4L6.8,194v-2.8L9.3,189.8 M9.3,188.7l-3.4,2v4l3.4,2l3.4-2v-4L9.3,188.7 L9.3,188.7z"
}));

var _ref394 = /*#__PURE__*/React.createElement("g", {
  id: "CA13"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "13.5,194.3 13.5,190.9 16.4,189.2 19.4,190.9 19.4,194.3 16.4,196  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M16.4,189.8l2.4,1.4v2.8l-2.4,1.4L14,194v-2.8L16.4,189.8 M16.4,188.7l-3.4,2v4l3.4,2l3.4-2v-4L16.4,188.7 L16.4,188.7z"
}));

var _ref395 = /*#__PURE__*/React.createElement("g", {
  id: "CA14"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "20.6,194.3 20.6,190.9 23.6,189.2 26.5,190.9 26.5,194.3 23.6,196  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M23.6,189.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L23.6,189.8 M23.6,188.7l-3.4,2v4l3.4,2l3.4-2v-4L23.6,188.7 L23.6,188.7z"
}));

var _ref396 = /*#__PURE__*/React.createElement("g", {
  id: "CA09"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "9.9,188.1 9.9,184.7 12.8,183 15.8,184.7 15.8,188.1 12.8,189.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M12.8,183.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V185L12.8,183.6 M12.8,182.5l-3.4,2v4l3.4,2l3.4-2v-4L12.8,182.5 L12.8,182.5z"
}));

var _ref397 = /*#__PURE__*/React.createElement("g", {
  id: "CA10"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "17.1,188.1 17.1,184.7 20,183 22.9,184.7 22.9,188.1 20,189.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M20,183.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V185L20,183.6 M20,182.5l-3.4,2v4l3.4,2l3.4-2v-4L20,182.5L20,182.5z"
}));

var _ref398 = /*#__PURE__*/React.createElement("g", {
  id: "CA11"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "24.2,188.1 24.2,184.7 27.2,183 30.1,184.7 30.1,188.1 27.2,189.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M27.2,183.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V185L27.2,183.6 M27.2,182.5l-3.4,2v4l3.4,2l3.4-2v-4L27.2,182.5 L27.2,182.5z"
}));

var _ref399 = /*#__PURE__*/React.createElement("g", {
  id: "CA15"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "2.7,200.5 2.7,197.2 5.7,195.5 8.6,197.2 8.6,200.5 5.7,202.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M5.7,196l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L5.7,196 M5.7,194.9l-3.4,2v4l3.4,2l3.4-2v-4L5.7,194.9L5.7,194.9 z"
}));

var _ref400 = /*#__PURE__*/React.createElement("g", {
  id: "CA19"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "6.3,206.7 6.3,203.3 9.2,201.6 12.2,203.3 12.2,206.7 9.2,208.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M9.2,202.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L9.2,202.2 M9.2,201.1l-3.4,2v4l3.4,2l3.4-2v-4L9.2,201.1 L9.2,201.1z"
}));

var _ref401 = /*#__PURE__*/React.createElement("g", {
  id: "CA20"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "13.4,206.7 13.4,203.3 16.4,201.6 19.3,203.3 19.3,206.7 16.4,208.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M16.4,202.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L16.4,202.2 M16.4,201.1l-3.4,2v4l3.4,2l3.4-2v-4L16.4,201.1 L16.4,201.1z"
}));

var _ref402 = /*#__PURE__*/React.createElement("g", {
  id: "CA21"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "20.6,206.7 20.6,203.3 23.5,201.6 26.5,203.3 26.5,206.7 23.5,208.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M23.5,202.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L23.5,202.2 M23.5,201.1l-3.4,2v4l3.4,2l3.4-2v-4L23.5,201.1 L23.5,201.1z"
}));

var _ref403 = /*#__PURE__*/React.createElement("g", {
  id: "CA22"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "27.8,206.7 27.8,203.3 30.7,201.6 33.6,203.3 33.6,206.7 30.7,208.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M30.7,202.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L30.7,202.2 M30.7,201.1l-3.4,2v4l3.4,2l3.4-2v-4L30.7,201.1 L30.7,201.1z"
}));

var _ref404 = /*#__PURE__*/React.createElement("g", {
  id: "CA16"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "9.9,200.5 9.9,197.1 12.8,195.4 15.8,197.1 15.8,200.5 12.8,202.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M12.8,196l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L12.8,196 M12.8,194.9l-3.4,2v4l3.4,2l3.4-2v-4L12.8,194.9 L12.8,194.9z"
}));

var _ref405 = /*#__PURE__*/React.createElement("g", {
  id: "CA17"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "17.1,200.5 17.1,197.2 20,195.5 22.9,197.2 22.9,200.5 20,202.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M20,196l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L20,196 M20,194.9l-3.4,2v4l3.4,2l3.4-2v-4L20,194.9L20,194.9z"
}));

var _ref406 = /*#__PURE__*/React.createElement("g", {
  id: "CA18"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "24.2,200.5 24.2,197.2 27.2,195.5 30.1,197.2 30.1,200.5 27.2,202.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M27.2,196l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L27.2,196 M27.2,194.9l-3.4,2v4l3.4,2l3.4-2v-4L27.2,194.9 L27.2,194.9z"
}));

var _ref407 = /*#__PURE__*/React.createElement("g", {
  id: "CA23"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "9.9,212.9 9.9,209.5 12.9,207.8 15.8,209.5 15.8,212.9 12.9,214.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M12.9,208.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L12.9,208.4 M12.9,207.2l-3.4,2v4l3.4,2l3.4-2v-4L12.9,207.2 L12.9,207.2z"
}));

var _ref408 = /*#__PURE__*/React.createElement("g", {
  id: "CA28"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "13.4,219.1 13.4,215.7 16.4,214 19.3,215.7 19.3,219.1 16.4,220.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M16.4,214.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V216L16.4,214.6 M16.4,213.4l-3.4,2v4l3.4,2l3.4-2v-4L16.4,213.4 L16.4,213.4z"
}));

var _ref409 = /*#__PURE__*/React.createElement("g", {
  id: "CA27"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "6.3,219.1 6.3,215.7 9.2,214 12.2,215.7 12.2,219.1 9.2,220.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M9.2,214.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V216L9.2,214.6 M9.2,213.4l-3.4,2v4l3.4,2l3.4-2v-4L9.2,213.4 L9.2,213.4z"
}));

var _ref410 = /*#__PURE__*/React.createElement("g", {
  id: "CA29"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "20.6,219.1 20.6,215.7 23.5,214 26.5,215.7 26.5,219.1 23.5,220.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M23.5,214.6L26,216v2.8l-2.4,1.4l-2.4-1.4V216L23.5,214.6 M23.5,213.4l-3.4,2v4l3.4,2l3.4-2v-4L23.5,213.4 L23.5,213.4z"
}));

var _ref411 = /*#__PURE__*/React.createElement("g", {
  id: "CA30"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "27.7,219.1 27.7,215.7 30.7,214 33.6,215.7 33.6,219.1 30.7,220.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M30.7,214.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V216L30.7,214.6 M30.7,213.4l-3.4,2v4l3.4,2l3.4-2v-4L30.7,213.4 L30.7,213.4z"
}));

var _ref412 = /*#__PURE__*/React.createElement("g", {
  id: "CA31"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "34.9,219.1 34.9,215.7 37.8,214 40.8,215.7 40.8,219.1 37.8,220.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M37.8,214.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V216L37.8,214.6 M37.8,213.4l-3.4,2v4l3.4,2l3.4-2v-4L37.8,213.4 L37.8,213.4z"
}));

var _ref413 = /*#__PURE__*/React.createElement("g", {
  id: "CA33"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "17.1,225.3 17.1,221.9 20,220.2 22.9,221.9 22.9,225.3 20,227  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M20,220.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L20,220.8 M20,219.6l-3.4,2v4l3.4,2l3.4-2v-4L20,219.6L20,219.6z "
}));

var _ref414 = /*#__PURE__*/React.createElement("g", {
  id: "CA32"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "9.9,225.3 9.9,221.9 12.9,220.2 15.8,221.9 15.8,225.3 12.9,227  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M12.9,220.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L12.9,220.8 M12.9,219.6l-3.4,2v4l3.4,2l3.4-2v-4L12.9,219.6 L12.9,219.6z"
}));

var _ref415 = /*#__PURE__*/React.createElement("g", {
  id: "CA34"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "24.2,225.3 24.2,221.9 27.1,220.2 30.1,221.9 30.1,225.3 27.1,227  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M27.1,220.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L27.1,220.8 M27.1,219.6l-3.4,2v4l3.4,2l3.4-2v-4L27.1,219.6 L27.1,219.6z"
}));

var _ref416 = /*#__PURE__*/React.createElement("g", {
  id: "CA35"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "31.4,225.3 31.4,221.9 34.3,220.2 37.2,221.9 37.2,225.3 34.3,227  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M34.3,220.8l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L34.3,220.8 M34.3,219.6l-3.4,2v4l3.4,2l3.4-2v-4L34.3,219.6 L34.3,219.6z"
}));

var _ref417 = /*#__PURE__*/React.createElement("g", {
  id: "CA36"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "38.5,225.3 38.5,221.9 41.4,220.2 44.4,221.9 44.4,225.3 41.4,227  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M41.4,220.8l2.4,1.4v2.8l-2.4,1.4L39,225v-2.8L41.4,220.8 M41.4,219.6l-3.4,2v4l3.4,2l3.4-2v-4L41.4,219.6 L41.4,219.6z"
}));

var _ref418 = /*#__PURE__*/React.createElement("g", {
  id: "CA38"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "20.7,231.5 20.7,228.1 23.6,226.4 26.5,228.1 26.5,231.5 23.6,233.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M23.6,227l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L23.6,227 M23.6,225.8l-3.4,2v4l3.4,2l3.4-2v-4L23.6,225.8 L23.6,225.8z"
}));

var _ref419 = /*#__PURE__*/React.createElement("g", {
  id: "CA37"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "13.5,231.5 13.5,228.1 16.4,226.4 19.4,228.1 19.4,231.5 16.4,233.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M16.4,227l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L16.4,227 M16.4,225.8l-3.4,2v4l3.4,2l3.4-2v-4L16.4,225.8 L16.4,225.8z"
}));

var _ref420 = /*#__PURE__*/React.createElement("g", {
  id: "CA39"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "27.8,231.5 27.8,228.1 30.7,226.4 33.6,228.1 33.6,231.5 30.7,233.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M30.7,227l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L30.7,227 M30.7,225.8l-3.4,2v4l3.4,2l3.4-2v-4L30.7,225.8 L30.7,225.8z"
}));

var _ref421 = /*#__PURE__*/React.createElement("g", {
  id: "CA40"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "34.9,231.5 34.9,228.1 37.8,226.4 40.8,228.1 40.8,231.5 37.8,233.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M37.8,227l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L37.8,227 M37.8,225.8l-3.4,2v4l3.4,2l3.4-2v-4L37.8,225.8 L37.8,225.8z"
}));

var _ref422 = /*#__PURE__*/React.createElement("g", {
  id: "CA41"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "42.1,231.5 42.1,228.1 45.1,226.4 48,228.1 48,231.5 45.1,233.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M45.1,227l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L45.1,227 M45.1,225.8l-3.4,2v4l3.4,2l3.4-2v-4L45.1,225.8 L45.1,225.8z"
}));

var _ref423 = /*#__PURE__*/React.createElement("g", {
  id: "CA43"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "24.2,237.7 24.2,234.3 27.2,232.6 30.1,234.3 30.1,237.7 27.2,239.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M27.2,233.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L27.2,233.2 M27.2,232l-3.4,2v4l3.4,2l3.4-2v-4L27.2,232 L27.2,232z"
}));

var _ref424 = /*#__PURE__*/React.createElement("g", {
  id: "CA42"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "17.1,237.7 17.1,234.3 20,232.6 23,234.3 23,237.7 20,239.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M20,233.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L20,233.2 M20,232l-3.4,2v4l3.4,2l3.4-2v-4L20,232L20,232z"
}));

var _ref425 = /*#__PURE__*/React.createElement("g", {
  id: "CA44"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "31.4,237.7 31.4,234.3 34.3,232.6 37.3,234.3 37.3,237.7 34.3,239.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M34.3,233.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L34.3,233.2 M34.3,232l-3.4,2v4l3.4,2l3.4-2v-4L34.3,232 L34.3,232z"
}));

var _ref426 = /*#__PURE__*/React.createElement("g", {
  id: "CA45"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "38.6,237.7 38.6,234.3 41.5,232.6 44.4,234.3 44.4,237.7 41.5,239.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M41.5,233.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L41.5,233.2 M41.5,232l-3.4,2v4l3.4,2l3.4-2v-4L41.5,232 L41.5,232z"
}));

var _ref427 = /*#__PURE__*/React.createElement("g", {
  id: "CA46"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "45.7,237.7 45.7,234.3 48.7,232.6 51.6,234.3 51.6,237.7 48.7,239.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M48.7,233.2l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L48.7,233.2 M48.7,232l-3.4,2v4l3.4,2l3.4-2v-4L48.7,232 L48.7,232z"
}));

var _ref428 = /*#__PURE__*/React.createElement("g", {
  id: "CA47"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "27.9,243.9 27.9,240.5 30.8,238.8 33.8,240.5 33.8,243.9 30.8,245.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M30.8,239.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L30.8,239.4 M30.8,238.2l-3.4,2v4l3.4,2l3.4-2v-4L30.8,238.2 L30.8,238.2z"
}));

var _ref429 = /*#__PURE__*/React.createElement("g", {
  id: "CA48"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "35,243.9 35,240.5 38,238.8 40.9,240.5 40.9,243.9 38,245.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M38,239.4l2.4,1.4v2.8L38,245l-2.4-1.4v-2.8L38,239.4 M38,238.2l-3.4,2v4l3.4,2l3.4-2v-4L38,238.2L38,238.2z"
}));

var _ref430 = /*#__PURE__*/React.createElement("g", {
  id: "CA49"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "42.2,243.9 42.2,240.5 45.1,238.8 48,240.5 48,243.9 45.1,245.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M45.1,239.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L45.1,239.4 M45.1,238.2l-3.4,2v4l3.4,2l3.4-2v-4L45.1,238.2 L45.1,238.2z"
}));

var _ref431 = /*#__PURE__*/React.createElement("g", {
  id: "CA50"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "49.3,243.9 49.3,240.5 52.2,238.8 55.2,240.5 55.2,243.9 52.2,245.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M52.2,239.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L52.2,239.4 M52.2,238.2l-3.4,2v4l3.4,2l3.4-2v-4L52.2,238.2 L52.2,238.2z"
}));

var _ref432 = /*#__PURE__*/React.createElement("g", {
  id: "CA51"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "38.6,250.1 38.6,246.7 41.6,245 44.5,246.7 44.5,250.1 41.6,251.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M41.6,245.6L44,247v2.8l-2.4,1.4l-2.4-1.4V247L41.6,245.6 M41.6,244.4l-3.4,2v4l3.4,2l3.4-2v-4L41.6,244.4 L41.6,244.4z"
}));

var _ref433 = /*#__PURE__*/React.createElement("g", {
  id: "CA52"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "45.7,250.1 45.7,246.7 48.7,245 51.6,246.7 51.6,250.1 48.7,251.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M48.7,245.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V247L48.7,245.6 M48.7,244.4l-3.4,2v4l3.4,2l3.4-2v-4L48.7,244.4 L48.7,244.4z"
}));

var _ref434 = /*#__PURE__*/React.createElement("g", {
  id: "CA53"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "52.9,250.1 52.9,246.7 55.8,245 58.8,246.7 58.8,250.1 55.8,251.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M55.8,245.6l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4V247L55.8,245.6 M55.8,244.4l-3.4,2v4l3.4,2l3.4-2v-4L55.8,244.4 L55.8,244.4z"
}));

var _ref435 = /*#__PURE__*/React.createElement("g", {
  id: "CA24"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "17.1,212.9 17.1,209.5 20,207.8 22.9,209.5 22.9,212.9 20,214.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M20,208.4l2.4,1.4v2.8L20,214l-2.4-1.4v-2.8L20,208.4 M20,207.2l-3.4,2v4l3.4,2l3.4-2v-4L20,207.2L20,207.2z"
}));

var _ref436 = /*#__PURE__*/React.createElement("g", {
  id: "CA25"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "24.2,212.9 24.2,209.5 27.2,207.8 30.1,209.5 30.1,212.9 27.2,214.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M27.2,208.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L27.2,208.4 M27.2,207.2l-3.4,2v4l3.4,2l3.4-2v-4L27.2,207.2 L27.2,207.2z"
}));

var _ref437 = /*#__PURE__*/React.createElement("g", {
  id: "CA26"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "31.4,212.9 31.4,209.5 34.3,207.8 37.2,209.5 37.2,212.9 34.3,214.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M34.3,208.4l2.4,1.4v2.8l-2.4,1.4l-2.4-1.4v-2.8L34.3,208.4 M34.3,207.2l-3.4,2v4l3.4,2l3.4-2v-4L34.3,207.2 L34.3,207.2z"
}));

var _ref438 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 23.665 116.4365)",
  className: "st2 st3 st4"
}, "WA");

var _ref439 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 4.7354 149.5861)",
  className: "st2 st3 st4"
}, "OR");

var _ref440 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 46.6997 151.0684)",
  className: "st2 st3 st4"
}, "ID");

var _ref441 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 87.4617 156.3585)",
  className: "st2 st3 st4"
}, "NE");

var _ref442 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 67.655 169.343)",
  className: "st2 st3 st4"
}, "CO");

var _ref443 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 36.4941 187.5352)",
  className: "st2 st3 st4"
}, "NV");

var _ref444 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 55.4426 187.5352)",
  className: "st2 st3 st4"
}, "UT");

var _ref445 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 75.8789 212.4873)",
  className: "st2 st3 st4"
}, "NM");

var _ref446 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 101.6194 197.5931)",
  className: "st2 st3 st4"
}, "KS");

var _ref447 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 110.0933 223.9844)",
  className: "st2 st3 st4"
}, "OK");

var _ref448 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 130.3203 219.2598)",
  className: "st2 st3 st4"
}, "AR");

var _ref449 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 163.2812 214.0791)",
  className: "st2 st3 st4"
}, "TN");

var _ref450 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 165.7136 231.7863)",
  className: "st2 st3 st4"
}, "MS");

var _ref451 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 262.104 234.6758)",
  className: "st2 st3 st4"
}, "SC");

var _ref452 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 275.104 211.1309)",
  className: "st2 st3 st4"
}, "NC");

var _ref453 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 279.9712 191.4372)",
  className: "st2 st3 st4"
}, "VA");

var _ref454 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 281.3047 164.0693)",
  className: "st2 st3 st4"
}, "MD");

var _ref455 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 309.6055 170.999)",
  className: "st2 st3 st4"
}, "DE");

var _ref456 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 236.2437 176.1309)",
  className: "st2 st3 st4"
}, "WV");

var _ref457 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 219.3149 144.4502)",
  className: "st2 st3 st4"
}, "OH");

var _ref458 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 246.1519 131.0898)",
  className: "st2 st3 st4"
}, "PA");

var _ref459 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 268.8721 105.5439)",
  className: "st2 st3 st4"
}, "NY");

var _ref460 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 316.5281 122.5516)",
  className: "st2 st3 st4"
}, "CT");

var _ref461 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 335.7354 122.5515)",
  className: "st2 st3 st4"
}, "RI");

var _ref462 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 313.4292 154.6904)",
  className: "st2 st3 st4"
}, "NJ");

var _ref463 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 324.8738 65.4482)",
  className: "st2 st3 st4"
}, "VT");

var _ref464 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 347.4377 73.1901)",
  className: "st2 st3 st4"
}, "NH");

var _ref465 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 347.4375 45.7236)",
  className: "st2 st3 st4"
}, "ME");

var _ref466 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 344.8394 94.0117)",
  className: "st2 st3 st4"
}, "MA");

var _ref467 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 191.8135 253.6328)",
  className: "st2 st3 st4"
}, "AL");

var _ref468 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 234.8628 253.0703)",
  className: "st2 st3 st4"
}, "GA");

var _ref469 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 218.0215 282.6975)",
  className: "st2 st3 st4"
}, "FL");

var _ref470 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 113.0703 187.0007)",
  className: "st2 st3 st4"
}, "MO");

var _ref471 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 200.3579 188.7705)",
  className: "st2 st3 st4"
}, "KY");

var _ref472 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 123.4277 162.2266)",
  className: "st2 st3 st4"
}, "IA");

var _ref473 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 62.0425 242.2725)",
  className: "st2 st3 st4"
}, "AZ");

var _ref474 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 101.6194 278.8586)",
  className: "st2 st3 st4"
}, "TX");

var _ref475 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 148.6226 260.8135)",
  className: "st2 st3 st4"
}, "LA");

var _ref476 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 52.5059 281.4736)",
  className: "st2 st3 st4"
}, "AK");

var _ref477 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 74.1665 281.4736)",
  className: "st2 st3 st4"
}, "HI");

var _ref478 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 3.5366 244.6846)",
  className: "st2 st3 st4"
}, "CA");

var _ref479 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 64.4497 116.4365)",
  className: "st2 st3 st4"
}, "MT");

var _ref480 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 62.2861 136.1289)",
  className: "st2 st3 st4"
}, "WY");

var _ref481 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 86.2485 136.1289)",
  className: "st2 st3 st4"
}, "SD");

var _ref482 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 86.0596 116.4365)",
  className: "st2 st3 st4"
}, "ND");

var _ref483 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 115.1313 116.4365)",
  className: "st2 st3 st4"
}, "MN");

var _ref484 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 154.6846 116.4365)",
  className: "st2 st3 st4"
}, "WI");

var _ref485 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 154.6846 158.8135)",
  className: "st2 st3 st4"
}, "IL");

var _ref486 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 186.6978 162.8135)",
  className: "st2 st3 st4"
}, "IN");

var _ref487 = /*#__PURE__*/React.createElement("text", {
  transform: "matrix(1 0 0 1 189.998 116.4365)",
  className: "st2 st3 st4"
}, "MI");

var SvgHousehex2020 = function SvgHousehex2020(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 40 371.5 270",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218, _ref219, _ref220, _ref221, _ref222, _ref223, _ref224, _ref225, _ref226, _ref227, _ref228, _ref229, _ref230, _ref231, _ref232, _ref233, _ref234, _ref235, _ref236, _ref237, _ref238, _ref239, _ref240, _ref241, _ref242, _ref243, _ref244, _ref245, _ref246, _ref247, _ref248, _ref249, _ref250, _ref251, _ref252, _ref253, _ref254, _ref255, _ref256, _ref257, _ref258, _ref259, _ref260, _ref261, _ref262, _ref263, _ref264, _ref265, _ref266, _ref267, _ref268, _ref269, _ref270, _ref271, _ref272, _ref273, _ref274, _ref275, _ref276, _ref277, _ref278, _ref279, _ref280, _ref281, _ref282, _ref283, _ref284, _ref285, _ref286, _ref287, _ref288, _ref289, _ref290, _ref291, _ref292, _ref293, _ref294, _ref295, _ref296, _ref297, _ref298, _ref299, _ref300, _ref301, _ref302, _ref303, _ref304, _ref305, _ref306, _ref307, _ref308, _ref309, _ref310, _ref311, _ref312, _ref313, _ref314, _ref315, _ref316, _ref317, _ref318, _ref319, _ref320, _ref321, _ref322, _ref323, _ref324, _ref325, _ref326, _ref327, _ref328, _ref329, _ref330, _ref331, _ref332, _ref333, _ref334, _ref335, _ref336, _ref337, _ref338, _ref339, _ref340, _ref341, _ref342, _ref343, _ref344, _ref345, _ref346, _ref347, _ref348, _ref349, _ref350, _ref351, _ref352, _ref353, _ref354, _ref355, _ref356, _ref357, _ref358, _ref359, _ref360, _ref361, _ref362, _ref363, _ref364, _ref365, _ref366, _ref367, _ref368, _ref369, _ref370, _ref371, _ref372, _ref373, _ref374, _ref375, _ref376, _ref377, _ref378, _ref379, _ref380, _ref381, _ref382, _ref383, _ref384, _ref385, _ref386, _ref387, _ref388, _ref389, _ref390, _ref391, _ref392, _ref393, _ref394, _ref395, _ref396, _ref397, _ref398, _ref399, _ref400, _ref401, _ref402, _ref403, _ref404, _ref405, _ref406, _ref407, _ref408, _ref409, _ref410, _ref411, _ref412, _ref413, _ref414, _ref415, _ref416, _ref417, _ref418, _ref419, _ref420, _ref421, _ref422, _ref423, _ref424, _ref425, _ref426, _ref427, _ref428, _ref429, _ref430, _ref431, _ref432, _ref433, _ref434, _ref435, _ref436, _ref437, _ref438, _ref439, _ref440, _ref441, _ref442, _ref443, _ref444, _ref445, _ref446, _ref447, _ref448, _ref449, _ref450, _ref451, _ref452, _ref453, _ref454, _ref455, _ref456, _ref457, _ref458, _ref459, _ref460, _ref461, _ref462, _ref463, _ref464, _ref465, _ref466, _ref467, _ref468, _ref469, _ref470, _ref471, _ref472, _ref473, _ref474, _ref475, _ref476, _ref477, _ref478, _ref479, _ref480, _ref481, _ref482, _ref483, _ref484, _ref485, _ref486, _ref487);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHousehex2020, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/househex2020.c59aeb20.svg";
export { ForwardRef as ReactComponent };